var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEcomm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "920px",
    height: "815px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,-0.5 C 4.5,-0.5 9.5,-0.5 14.5,-0.5C 14.5,4.5 14.5,9.5 14.5,14.5C 9.5,14.5 4.5,14.5 -0.5,14.5C -0.5,9.5 -0.5,4.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,-0.5 C 19.5,-0.5 24.5,-0.5 29.5,-0.5C 29.5,4.5 29.5,9.5 29.5,14.5C 24.5,14.5 19.5,14.5 14.5,14.5C 14.5,9.5 14.5,4.5 14.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,-0.5 C 34.5,-0.5 39.5,-0.5 44.5,-0.5C 44.5,4.5 44.5,9.5 44.5,14.5C 39.5,14.5 34.5,14.5 29.5,14.5C 29.5,9.5 29.5,4.5 29.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,-0.5 C 49.5,-0.5 54.5,-0.5 59.5,-0.5C 59.5,4.5 59.5,9.5 59.5,14.5C 54.5,14.5 49.5,14.5 44.5,14.5C 44.5,9.5 44.5,4.5 44.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,-0.5 C 64.5,-0.5 69.5,-0.5 74.5,-0.5C 74.5,4.5 74.5,9.5 74.5,14.5C 69.5,14.5 64.5,14.5 59.5,14.5C 59.5,9.5 59.5,4.5 59.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 74.5,-0.5 C 79.5,-0.5 84.5,-0.5 89.5,-0.5C 89.5,4.5 89.5,9.5 89.5,14.5C 84.5,14.5 79.5,14.5 74.5,14.5C 74.5,9.5 74.5,4.5 74.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 89.5,-0.5 C 94.5,-0.5 99.5,-0.5 104.5,-0.5C 104.5,4.5 104.5,9.5 104.5,14.5C 99.5,14.5 94.5,14.5 89.5,14.5C 89.5,9.5 89.5,4.5 89.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 104.5,-0.5 C 109.5,-0.5 114.5,-0.5 119.5,-0.5C 119.5,4.5 119.5,9.5 119.5,14.5C 114.5,14.5 109.5,14.5 104.5,14.5C 104.5,9.5 104.5,4.5 104.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,-0.5 C 124.5,-0.5 129.5,-0.5 134.5,-0.5C 134.5,4.5 134.5,9.5 134.5,14.5C 129.5,14.5 124.5,14.5 119.5,14.5C 119.5,9.5 119.5,4.5 119.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 134.5,-0.5 C 139.5,-0.5 144.5,-0.5 149.5,-0.5C 149.5,4.5 149.5,9.5 149.5,14.5C 144.5,14.5 139.5,14.5 134.5,14.5C 134.5,9.5 134.5,4.5 134.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 149.5,-0.5 C 154.5,-0.5 159.5,-0.5 164.5,-0.5C 164.5,4.5 164.5,9.5 164.5,14.5C 159.5,14.5 154.5,14.5 149.5,14.5C 149.5,9.5 149.5,4.5 149.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 164.5,-0.5 C 169.5,-0.5 174.5,-0.5 179.5,-0.5C 179.5,4.5 179.5,9.5 179.5,14.5C 174.5,14.5 169.5,14.5 164.5,14.5C 164.5,9.5 164.5,4.5 164.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 179.5,-0.5 C 184.5,-0.5 189.5,-0.5 194.5,-0.5C 194.5,4.5 194.5,9.5 194.5,14.5C 189.5,14.5 184.5,14.5 179.5,14.5C 179.5,9.5 179.5,4.5 179.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 194.5,-0.5 C 199.5,-0.5 204.5,-0.5 209.5,-0.5C 209.5,4.5 209.5,9.5 209.5,14.5C 204.5,14.5 199.5,14.5 194.5,14.5C 194.5,9.5 194.5,4.5 194.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 209.5,-0.5 C 214.5,-0.5 219.5,-0.5 224.5,-0.5C 224.5,4.5 224.5,9.5 224.5,14.5C 219.5,14.5 214.5,14.5 209.5,14.5C 209.5,9.5 209.5,4.5 209.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 224.5,-0.5 C 229.5,-0.5 234.5,-0.5 239.5,-0.5C 239.5,4.5 239.5,9.5 239.5,14.5C 234.5,14.5 229.5,14.5 224.5,14.5C 224.5,9.5 224.5,4.5 224.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 239.5,-0.5 C 244.5,-0.5 249.5,-0.5 254.5,-0.5C 254.5,4.5 254.5,9.5 254.5,14.5C 249.5,14.5 244.5,14.5 239.5,14.5C 239.5,9.5 239.5,4.5 239.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 254.5,-0.5 C 259.5,-0.5 264.5,-0.5 269.5,-0.5C 269.5,4.5 269.5,9.5 269.5,14.5C 264.5,14.5 259.5,14.5 254.5,14.5C 254.5,9.5 254.5,4.5 254.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 269.5,-0.5 C 274.5,-0.5 279.5,-0.5 284.5,-0.5C 284.5,4.5 284.5,9.5 284.5,14.5C 279.5,14.5 274.5,14.5 269.5,14.5C 269.5,9.5 269.5,4.5 269.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 284.5,-0.5 C 289.5,-0.5 294.5,-0.5 299.5,-0.5C 299.5,4.5 299.5,9.5 299.5,14.5C 294.5,14.5 289.5,14.5 284.5,14.5C 284.5,9.5 284.5,4.5 284.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 299.5,-0.5 C 304.5,-0.5 309.5,-0.5 314.5,-0.5C 314.5,4.5 314.5,9.5 314.5,14.5C 309.5,14.5 304.5,14.5 299.5,14.5C 299.5,9.5 299.5,4.5 299.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 314.5,-0.5 C 319.5,-0.5 324.5,-0.5 329.5,-0.5C 329.5,4.5 329.5,9.5 329.5,14.5C 324.5,14.5 319.5,14.5 314.5,14.5C 314.5,9.5 314.5,4.5 314.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 329.5,-0.5 C 334.5,-0.5 339.5,-0.5 344.5,-0.5C 344.5,4.5 344.5,9.5 344.5,14.5C 339.5,14.5 334.5,14.5 329.5,14.5C 329.5,9.5 329.5,4.5 329.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f4f4",
    d: "M 344.5,-0.5 C 404.5,-0.5 464.5,-0.5 524.5,-0.5C 524.5,4.5 524.5,9.5 524.5,14.5C 529.5,14.5 534.5,14.5 539.5,14.5C 539.5,9.5 539.5,4.5 539.5,-0.5C 544.5,-0.5 549.5,-0.5 554.5,-0.5C 554.5,4.5 554.5,9.5 554.5,14.5C 559.5,14.5 564.5,14.5 569.5,14.5C 568.985,19.4797 569.652,24.1464 571.5,28.5C 496.025,7.90697 420.359,7.24031 344.5,26.5C 344.5,22.5 344.5,18.5 344.5,14.5C 344.5,9.5 344.5,4.5 344.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 524.5,-0.5 C 529.5,-0.5 534.5,-0.5 539.5,-0.5C 539.5,4.5 539.5,9.5 539.5,14.5C 534.5,14.5 529.5,14.5 524.5,14.5C 524.5,9.5 524.5,4.5 524.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 554.5,-0.5 C 559.5,-0.5 564.5,-0.5 569.5,-0.5C 569.5,4.5 569.5,9.5 569.5,14.5C 564.5,14.5 559.5,14.5 554.5,14.5C 554.5,9.5 554.5,4.5 554.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 569.5,-0.5 C 574.5,-0.5 579.5,-0.5 584.5,-0.5C 584.5,4.5 584.5,9.5 584.5,14.5C 579.5,14.5 574.5,14.5 569.5,14.5C 569.5,9.5 569.5,4.5 569.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 584.5,-0.5 C 589.5,-0.5 594.5,-0.5 599.5,-0.5C 599.5,4.5 599.5,9.5 599.5,14.5C 594.5,14.5 589.5,14.5 584.5,14.5C 584.5,9.5 584.5,4.5 584.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 599.5,-0.5 C 604.5,-0.5 609.5,-0.5 614.5,-0.5C 614.5,4.5 614.5,9.5 614.5,14.5C 609.5,14.5 604.5,14.5 599.5,14.5C 599.5,9.5 599.5,4.5 599.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 614.5,-0.5 C 619.5,-0.5 624.5,-0.5 629.5,-0.5C 629.5,4.5 629.5,9.5 629.5,14.5C 624.5,14.5 619.5,14.5 614.5,14.5C 614.5,9.5 614.5,4.5 614.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 629.5,-0.5 C 634.5,-0.5 639.5,-0.5 644.5,-0.5C 644.5,4.5 644.5,9.5 644.5,14.5C 639.5,14.5 634.5,14.5 629.5,14.5C 629.5,9.5 629.5,4.5 629.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 644.5,-0.5 C 649.5,-0.5 654.5,-0.5 659.5,-0.5C 659.5,4.5 659.5,9.5 659.5,14.5C 654.5,14.5 649.5,14.5 644.5,14.5C 644.5,9.5 644.5,4.5 644.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 659.5,-0.5 C 664.5,-0.5 669.5,-0.5 674.5,-0.5C 674.5,4.5 674.5,9.5 674.5,14.5C 669.5,14.5 664.5,14.5 659.5,14.5C 659.5,9.5 659.5,4.5 659.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 674.5,-0.5 C 679.5,-0.5 684.5,-0.5 689.5,-0.5C 689.5,4.5 689.5,9.5 689.5,14.5C 684.5,14.5 679.5,14.5 674.5,14.5C 674.5,9.5 674.5,4.5 674.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 689.5,-0.5 C 694.5,-0.5 699.5,-0.5 704.5,-0.5C 704.5,4.5 704.5,9.5 704.5,14.5C 699.5,14.5 694.5,14.5 689.5,14.5C 689.5,9.5 689.5,4.5 689.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 704.5,-0.5 C 709.5,-0.5 714.5,-0.5 719.5,-0.5C 719.5,4.5 719.5,9.5 719.5,14.5C 714.5,14.5 709.5,14.5 704.5,14.5C 704.5,9.5 704.5,4.5 704.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 719.5,-0.5 C 724.5,-0.5 729.5,-0.5 734.5,-0.5C 734.5,4.5 734.5,9.5 734.5,14.5C 729.5,14.5 724.5,14.5 719.5,14.5C 719.5,9.5 719.5,4.5 719.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 734.5,-0.5 C 739.5,-0.5 744.5,-0.5 749.5,-0.5C 749.5,4.5 749.5,9.5 749.5,14.5C 744.5,14.5 739.5,14.5 734.5,14.5C 734.5,9.5 734.5,4.5 734.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 749.5,-0.5 C 754.5,-0.5 759.5,-0.5 764.5,-0.5C 764.5,4.5 764.5,9.5 764.5,14.5C 759.5,14.5 754.5,14.5 749.5,14.5C 749.5,9.5 749.5,4.5 749.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,-0.5 C 769.5,-0.5 774.5,-0.5 779.5,-0.5C 779.5,4.5 779.5,9.5 779.5,14.5C 774.5,14.5 769.5,14.5 764.5,14.5C 764.5,9.5 764.5,4.5 764.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,-0.5 C 784.5,-0.5 789.5,-0.5 794.5,-0.5C 794.5,4.5 794.5,9.5 794.5,14.5C 789.5,14.5 784.5,14.5 779.5,14.5C 779.5,9.5 779.5,4.5 779.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,-0.5 C 799.5,-0.5 804.5,-0.5 809.5,-0.5C 809.5,4.5 809.5,9.5 809.5,14.5C 804.5,14.5 799.5,14.5 794.5,14.5C 794.5,9.5 794.5,4.5 794.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,-0.5 C 814.5,-0.5 819.5,-0.5 824.5,-0.5C 824.5,4.5 824.5,9.5 824.5,14.5C 819.5,14.5 814.5,14.5 809.5,14.5C 809.5,9.5 809.5,4.5 809.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,-0.5 C 829.5,-0.5 834.5,-0.5 839.5,-0.5C 839.5,4.5 839.5,9.5 839.5,14.5C 834.5,14.5 829.5,14.5 824.5,14.5C 824.5,9.5 824.5,4.5 824.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,-0.5 C 844.5,-0.5 849.5,-0.5 854.5,-0.5C 854.5,4.5 854.5,9.5 854.5,14.5C 849.5,14.5 844.5,14.5 839.5,14.5C 839.5,9.5 839.5,4.5 839.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,-0.5 C 859.5,-0.5 864.5,-0.5 869.5,-0.5C 869.5,4.5 869.5,9.5 869.5,14.5C 864.5,14.5 859.5,14.5 854.5,14.5C 854.5,9.5 854.5,4.5 854.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,-0.5 C 874.5,-0.5 879.5,-0.5 884.5,-0.5C 884.5,4.5 884.5,9.5 884.5,14.5C 879.5,14.5 874.5,14.5 869.5,14.5C 869.5,9.5 869.5,4.5 869.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efefef",
    d: "M 884.5,-0.5 C 896.167,-0.5 907.833,-0.5 919.5,-0.5C 919.5,271.167 919.5,542.833 919.5,814.5C 912.833,814.5 906.167,814.5 899.5,814.5C 899.5,812.833 899.5,811.167 899.5,809.5C 899.5,804.5 899.5,799.5 899.5,794.5C 904.5,794.5 909.5,794.5 914.5,794.5C 914.5,789.5 914.5,784.5 914.5,779.5C 909.5,779.5 904.5,779.5 899.5,779.5C 899.5,774.5 899.5,769.5 899.5,764.5C 904.5,764.5 909.5,764.5 914.5,764.5C 914.5,759.5 914.5,754.5 914.5,749.5C 909.5,749.5 904.5,749.5 899.5,749.5C 899.5,744.5 899.5,739.5 899.5,734.5C 904.5,734.5 909.5,734.5 914.5,734.5C 914.5,729.5 914.5,724.5 914.5,719.5C 909.5,719.5 904.5,719.5 899.5,719.5C 899.5,714.5 899.5,709.5 899.5,704.5C 904.5,704.5 909.5,704.5 914.5,704.5C 914.5,699.5 914.5,694.5 914.5,689.5C 909.5,689.5 904.5,689.5 899.5,689.5C 899.5,684.5 899.5,679.5 899.5,674.5C 904.5,674.5 909.5,674.5 914.5,674.5C 914.5,669.5 914.5,664.5 914.5,659.5C 909.5,659.5 904.5,659.5 899.5,659.5C 899.5,654.5 899.5,649.5 899.5,644.5C 904.5,644.5 909.5,644.5 914.5,644.5C 914.5,639.5 914.5,634.5 914.5,629.5C 909.5,629.5 904.5,629.5 899.5,629.5C 899.5,624.5 899.5,619.5 899.5,614.5C 904.5,614.5 909.5,614.5 914.5,614.5C 914.5,609.5 914.5,604.5 914.5,599.5C 909.5,599.5 904.5,599.5 899.5,599.5C 899.5,594.5 899.5,589.5 899.5,584.5C 904.5,584.5 909.5,584.5 914.5,584.5C 914.5,579.5 914.5,574.5 914.5,569.5C 909.5,569.5 904.5,569.5 899.5,569.5C 899.5,564.5 899.5,559.5 899.5,554.5C 904.5,554.5 909.5,554.5 914.5,554.5C 914.5,549.5 914.5,544.5 914.5,539.5C 909.5,539.5 904.5,539.5 899.5,539.5C 899.5,534.5 899.5,529.5 899.5,524.5C 904.5,524.5 909.5,524.5 914.5,524.5C 914.5,519.5 914.5,514.5 914.5,509.5C 909.5,509.5 904.5,509.5 899.5,509.5C 899.5,504.5 899.5,499.5 899.5,494.5C 904.5,494.5 909.5,494.5 914.5,494.5C 914.5,489.5 914.5,484.5 914.5,479.5C 909.5,479.5 904.5,479.5 899.5,479.5C 899.5,474.5 899.5,469.5 899.5,464.5C 904.5,464.5 909.5,464.5 914.5,464.5C 914.5,459.5 914.5,454.5 914.5,449.5C 909.5,449.5 904.5,449.5 899.5,449.5C 899.5,444.5 899.5,439.5 899.5,434.5C 904.5,434.5 909.5,434.5 914.5,434.5C 914.5,429.5 914.5,424.5 914.5,419.5C 909.5,419.5 904.5,419.5 899.5,419.5C 899.5,404.5 899.5,389.5 899.5,374.5C 904.5,374.5 909.5,374.5 914.5,374.5C 914.5,369.5 914.5,364.5 914.5,359.5C 909.5,359.5 904.5,359.5 899.5,359.5C 899.5,354.5 899.5,349.5 899.5,344.5C 904.5,344.5 909.5,344.5 914.5,344.5C 914.5,339.5 914.5,334.5 914.5,329.5C 909.5,329.5 904.5,329.5 899.5,329.5C 899.5,324.5 899.5,319.5 899.5,314.5C 904.5,314.5 909.5,314.5 914.5,314.5C 914.5,309.5 914.5,304.5 914.5,299.5C 909.5,299.5 904.5,299.5 899.5,299.5C 899.5,294.5 899.5,289.5 899.5,284.5C 904.5,284.5 909.5,284.5 914.5,284.5C 914.5,279.5 914.5,274.5 914.5,269.5C 909.5,269.5 904.5,269.5 899.5,269.5C 899.5,264.5 899.5,259.5 899.5,254.5C 894.5,254.5 889.5,254.5 884.5,254.5C 884.5,249.5 884.5,244.5 884.5,239.5C 884.5,234.5 884.5,229.5 884.5,224.5C 884.5,219.5 884.5,214.5 884.5,209.5C 884.5,204.5 884.5,199.5 884.5,194.5C 884.5,189.5 884.5,184.5 884.5,179.5C 884.5,174.5 884.5,169.5 884.5,164.5C 884.5,159.5 884.5,154.5 884.5,149.5C 884.5,144.5 884.5,139.5 884.5,134.5C 884.5,129.5 884.5,124.5 884.5,119.5C 884.5,114.5 884.5,109.5 884.5,104.5C 884.5,99.5 884.5,94.5 884.5,89.5C 884.5,84.5 884.5,79.5 884.5,74.5C 884.5,69.5 884.5,64.5 884.5,59.5C 884.5,54.5 884.5,49.5 884.5,44.5C 884.5,39.5 884.5,34.5 884.5,29.5C 884.5,24.5 884.5,19.5 884.5,14.5C 884.5,9.5 884.5,4.5 884.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#de1a32",
    d: "M 571.5,28.5 C 596.14,36.8158 620.14,46.8158 643.5,58.5C 659.328,68.2473 674.995,78.2473 690.5,88.5C 719.167,111.167 744.833,136.833 767.5,165.5C 777.952,179.625 787.619,194.291 796.5,209.5C 801.516,218.868 806.516,228.201 811.5,237.5C 820.428,257.951 827.761,278.951 833.5,300.5C 838.344,318.721 842.011,337.055 844.5,355.5C 851.827,424.865 841.827,491.531 814.5,555.5C 810.204,564.764 805.87,574.098 801.5,583.5C 794.841,594.495 788.174,605.495 781.5,616.5C 767.611,636.231 752.278,654.897 735.5,672.5C 734.167,673.167 733.167,674.167 732.5,675.5C 714.599,693.416 695.266,709.416 674.5,723.5C 574.782,787.173 467.449,804.006 352.5,774C 312.332,762.579 274.666,745.746 239.5,723.5C 125.288,645.252 66.6209,536.418 63.5,397C 64.4013,317.475 87.0679,244.975 131.5,179.5C 157.419,142.914 188.419,111.247 224.5,84.5C 239.5,74.6644 254.833,65.3311 270.5,56.5C 294.303,44.2616 318.97,34.2616 344.5,26.5C 420.359,7.24031 496.025,7.90697 571.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,14.5 C 4.5,14.5 9.5,14.5 14.5,14.5C 14.5,19.5 14.5,24.5 14.5,29.5C 9.5,29.5 4.5,29.5 -0.5,29.5C -0.5,24.5 -0.5,19.5 -0.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,14.5 C 19.5,14.5 24.5,14.5 29.5,14.5C 29.5,19.5 29.5,24.5 29.5,29.5C 24.5,29.5 19.5,29.5 14.5,29.5C 14.5,24.5 14.5,19.5 14.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,14.5 C 34.5,14.5 39.5,14.5 44.5,14.5C 44.5,19.5 44.5,24.5 44.5,29.5C 39.5,29.5 34.5,29.5 29.5,29.5C 29.5,24.5 29.5,19.5 29.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,14.5 C 49.5,14.5 54.5,14.5 59.5,14.5C 59.5,19.5 59.5,24.5 59.5,29.5C 54.5,29.5 49.5,29.5 44.5,29.5C 44.5,24.5 44.5,19.5 44.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 59.5,14.5 C 64.5,14.5 69.5,14.5 74.5,14.5C 74.5,19.5 74.5,24.5 74.5,29.5C 69.5,29.5 64.5,29.5 59.5,29.5C 59.5,24.5 59.5,19.5 59.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 74.5,14.5 C 79.5,14.5 84.5,14.5 89.5,14.5C 89.5,19.5 89.5,24.5 89.5,29.5C 84.5,29.5 79.5,29.5 74.5,29.5C 74.5,24.5 74.5,19.5 74.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 89.5,14.5 C 94.5,14.5 99.5,14.5 104.5,14.5C 104.5,19.5 104.5,24.5 104.5,29.5C 99.5,29.5 94.5,29.5 89.5,29.5C 89.5,24.5 89.5,19.5 89.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 104.5,14.5 C 109.5,14.5 114.5,14.5 119.5,14.5C 119.5,19.5 119.5,24.5 119.5,29.5C 114.5,29.5 109.5,29.5 104.5,29.5C 104.5,24.5 104.5,19.5 104.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 119.5,14.5 C 124.5,14.5 129.5,14.5 134.5,14.5C 134.5,19.5 134.5,24.5 134.5,29.5C 129.5,29.5 124.5,29.5 119.5,29.5C 119.5,24.5 119.5,19.5 119.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 134.5,14.5 C 139.5,14.5 144.5,14.5 149.5,14.5C 149.5,19.5 149.5,24.5 149.5,29.5C 144.5,29.5 139.5,29.5 134.5,29.5C 134.5,24.5 134.5,19.5 134.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 149.5,14.5 C 154.5,14.5 159.5,14.5 164.5,14.5C 164.5,19.5 164.5,24.5 164.5,29.5C 159.5,29.5 154.5,29.5 149.5,29.5C 149.5,24.5 149.5,19.5 149.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 164.5,14.5 C 169.5,14.5 174.5,14.5 179.5,14.5C 179.5,19.5 179.5,24.5 179.5,29.5C 174.5,29.5 169.5,29.5 164.5,29.5C 164.5,24.5 164.5,19.5 164.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 179.5,14.5 C 184.5,14.5 189.5,14.5 194.5,14.5C 194.5,19.5 194.5,24.5 194.5,29.5C 189.5,29.5 184.5,29.5 179.5,29.5C 179.5,24.5 179.5,19.5 179.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 194.5,14.5 C 199.5,14.5 204.5,14.5 209.5,14.5C 209.5,19.5 209.5,24.5 209.5,29.5C 204.5,29.5 199.5,29.5 194.5,29.5C 194.5,24.5 194.5,19.5 194.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 209.5,14.5 C 214.5,14.5 219.5,14.5 224.5,14.5C 224.5,19.5 224.5,24.5 224.5,29.5C 219.5,29.5 214.5,29.5 209.5,29.5C 209.5,24.5 209.5,19.5 209.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 224.5,14.5 C 229.5,14.5 234.5,14.5 239.5,14.5C 239.5,19.5 239.5,24.5 239.5,29.5C 234.5,29.5 229.5,29.5 224.5,29.5C 224.5,24.5 224.5,19.5 224.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 239.5,14.5 C 244.5,14.5 249.5,14.5 254.5,14.5C 254.5,19.5 254.5,24.5 254.5,29.5C 249.5,29.5 244.5,29.5 239.5,29.5C 239.5,24.5 239.5,19.5 239.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 254.5,14.5 C 259.5,14.5 264.5,14.5 269.5,14.5C 269.5,19.5 269.5,24.5 269.5,29.5C 264.5,29.5 259.5,29.5 254.5,29.5C 254.5,24.5 254.5,19.5 254.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 269.5,14.5 C 274.5,14.5 279.5,14.5 284.5,14.5C 284.5,19.5 284.5,24.5 284.5,29.5C 279.5,29.5 274.5,29.5 269.5,29.5C 269.5,24.5 269.5,19.5 269.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 284.5,14.5 C 289.5,14.5 294.5,14.5 299.5,14.5C 299.5,19.5 299.5,24.5 299.5,29.5C 294.5,29.5 289.5,29.5 284.5,29.5C 284.5,24.5 284.5,19.5 284.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 614.5,14.5 C 619.5,14.5 624.5,14.5 629.5,14.5C 629.5,19.5 629.5,24.5 629.5,29.5C 624.5,29.5 619.5,29.5 614.5,29.5C 614.5,24.5 614.5,19.5 614.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 629.5,14.5 C 634.5,14.5 639.5,14.5 644.5,14.5C 644.5,19.5 644.5,24.5 644.5,29.5C 639.5,29.5 634.5,29.5 629.5,29.5C 629.5,24.5 629.5,19.5 629.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 644.5,14.5 C 649.5,14.5 654.5,14.5 659.5,14.5C 659.5,19.5 659.5,24.5 659.5,29.5C 654.5,29.5 649.5,29.5 644.5,29.5C 644.5,24.5 644.5,19.5 644.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 659.5,14.5 C 664.5,14.5 669.5,14.5 674.5,14.5C 674.5,19.5 674.5,24.5 674.5,29.5C 669.5,29.5 664.5,29.5 659.5,29.5C 659.5,24.5 659.5,19.5 659.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 674.5,14.5 C 679.5,14.5 684.5,14.5 689.5,14.5C 689.5,19.5 689.5,24.5 689.5,29.5C 684.5,29.5 679.5,29.5 674.5,29.5C 674.5,24.5 674.5,19.5 674.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 689.5,14.5 C 694.5,14.5 699.5,14.5 704.5,14.5C 704.5,19.5 704.5,24.5 704.5,29.5C 699.5,29.5 694.5,29.5 689.5,29.5C 689.5,24.5 689.5,19.5 689.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 704.5,14.5 C 709.5,14.5 714.5,14.5 719.5,14.5C 719.5,19.5 719.5,24.5 719.5,29.5C 714.5,29.5 709.5,29.5 704.5,29.5C 704.5,24.5 704.5,19.5 704.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 719.5,14.5 C 724.5,14.5 729.5,14.5 734.5,14.5C 734.5,19.5 734.5,24.5 734.5,29.5C 729.5,29.5 724.5,29.5 719.5,29.5C 719.5,24.5 719.5,19.5 719.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 734.5,14.5 C 739.5,14.5 744.5,14.5 749.5,14.5C 749.5,19.5 749.5,24.5 749.5,29.5C 744.5,29.5 739.5,29.5 734.5,29.5C 734.5,24.5 734.5,19.5 734.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 749.5,14.5 C 754.5,14.5 759.5,14.5 764.5,14.5C 764.5,19.5 764.5,24.5 764.5,29.5C 759.5,29.5 754.5,29.5 749.5,29.5C 749.5,24.5 749.5,19.5 749.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,14.5 C 769.5,14.5 774.5,14.5 779.5,14.5C 779.5,19.5 779.5,24.5 779.5,29.5C 774.5,29.5 769.5,29.5 764.5,29.5C 764.5,24.5 764.5,19.5 764.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,14.5 C 784.5,14.5 789.5,14.5 794.5,14.5C 794.5,19.5 794.5,24.5 794.5,29.5C 789.5,29.5 784.5,29.5 779.5,29.5C 779.5,24.5 779.5,19.5 779.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,14.5 C 799.5,14.5 804.5,14.5 809.5,14.5C 809.5,19.5 809.5,24.5 809.5,29.5C 804.5,29.5 799.5,29.5 794.5,29.5C 794.5,24.5 794.5,19.5 794.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,14.5 C 814.5,14.5 819.5,14.5 824.5,14.5C 824.5,19.5 824.5,24.5 824.5,29.5C 819.5,29.5 814.5,29.5 809.5,29.5C 809.5,24.5 809.5,19.5 809.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,14.5 C 829.5,14.5 834.5,14.5 839.5,14.5C 839.5,19.5 839.5,24.5 839.5,29.5C 834.5,29.5 829.5,29.5 824.5,29.5C 824.5,24.5 824.5,19.5 824.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,14.5 C 844.5,14.5 849.5,14.5 854.5,14.5C 854.5,19.5 854.5,24.5 854.5,29.5C 849.5,29.5 844.5,29.5 839.5,29.5C 839.5,24.5 839.5,19.5 839.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 854.5,14.5 C 859.5,14.5 864.5,14.5 869.5,14.5C 869.5,19.5 869.5,24.5 869.5,29.5C 864.5,29.5 859.5,29.5 854.5,29.5C 854.5,24.5 854.5,19.5 854.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 869.5,14.5 C 874.5,14.5 879.5,14.5 884.5,14.5C 884.5,19.5 884.5,24.5 884.5,29.5C 879.5,29.5 874.5,29.5 869.5,29.5C 869.5,24.5 869.5,19.5 869.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,29.5 C 4.5,29.5 9.5,29.5 14.5,29.5C 14.5,34.5 14.5,39.5 14.5,44.5C 9.5,44.5 4.5,44.5 -0.5,44.5C -0.5,39.5 -0.5,34.5 -0.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,29.5 C 19.5,29.5 24.5,29.5 29.5,29.5C 29.5,34.5 29.5,39.5 29.5,44.5C 24.5,44.5 19.5,44.5 14.5,44.5C 14.5,39.5 14.5,34.5 14.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,29.5 C 34.5,29.5 39.5,29.5 44.5,29.5C 44.5,34.5 44.5,39.5 44.5,44.5C 39.5,44.5 34.5,44.5 29.5,44.5C 29.5,39.5 29.5,34.5 29.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,29.5 C 49.5,29.5 54.5,29.5 59.5,29.5C 59.5,34.5 59.5,39.5 59.5,44.5C 54.5,44.5 49.5,44.5 44.5,44.5C 44.5,39.5 44.5,34.5 44.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,29.5 C 64.5,29.5 69.5,29.5 74.5,29.5C 74.5,34.5 74.5,39.5 74.5,44.5C 69.5,44.5 64.5,44.5 59.5,44.5C 59.5,39.5 59.5,34.5 59.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 74.5,29.5 C 79.5,29.5 84.5,29.5 89.5,29.5C 89.5,34.5 89.5,39.5 89.5,44.5C 84.5,44.5 79.5,44.5 74.5,44.5C 74.5,39.5 74.5,34.5 74.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 89.5,29.5 C 94.5,29.5 99.5,29.5 104.5,29.5C 104.5,34.5 104.5,39.5 104.5,44.5C 99.5,44.5 94.5,44.5 89.5,44.5C 89.5,39.5 89.5,34.5 89.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 104.5,29.5 C 109.5,29.5 114.5,29.5 119.5,29.5C 119.5,34.5 119.5,39.5 119.5,44.5C 114.5,44.5 109.5,44.5 104.5,44.5C 104.5,39.5 104.5,34.5 104.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,29.5 C 124.5,29.5 129.5,29.5 134.5,29.5C 134.5,34.5 134.5,39.5 134.5,44.5C 129.5,44.5 124.5,44.5 119.5,44.5C 119.5,39.5 119.5,34.5 119.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 134.5,29.5 C 139.5,29.5 144.5,29.5 149.5,29.5C 149.5,34.5 149.5,39.5 149.5,44.5C 144.5,44.5 139.5,44.5 134.5,44.5C 134.5,39.5 134.5,34.5 134.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 149.5,29.5 C 154.5,29.5 159.5,29.5 164.5,29.5C 164.5,34.5 164.5,39.5 164.5,44.5C 159.5,44.5 154.5,44.5 149.5,44.5C 149.5,39.5 149.5,34.5 149.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 164.5,29.5 C 169.5,29.5 174.5,29.5 179.5,29.5C 179.5,34.5 179.5,39.5 179.5,44.5C 174.5,44.5 169.5,44.5 164.5,44.5C 164.5,39.5 164.5,34.5 164.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 179.5,29.5 C 184.5,29.5 189.5,29.5 194.5,29.5C 194.5,34.5 194.5,39.5 194.5,44.5C 189.5,44.5 184.5,44.5 179.5,44.5C 179.5,39.5 179.5,34.5 179.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 194.5,29.5 C 199.5,29.5 204.5,29.5 209.5,29.5C 209.5,34.5 209.5,39.5 209.5,44.5C 204.5,44.5 199.5,44.5 194.5,44.5C 194.5,39.5 194.5,34.5 194.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 209.5,29.5 C 214.5,29.5 219.5,29.5 224.5,29.5C 224.5,34.5 224.5,39.5 224.5,44.5C 219.5,44.5 214.5,44.5 209.5,44.5C 209.5,39.5 209.5,34.5 209.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 224.5,29.5 C 229.5,29.5 234.5,29.5 239.5,29.5C 239.5,34.5 239.5,39.5 239.5,44.5C 234.5,44.5 229.5,44.5 224.5,44.5C 224.5,39.5 224.5,34.5 224.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 239.5,29.5 C 244.5,29.5 249.5,29.5 254.5,29.5C 254.5,34.5 254.5,39.5 254.5,44.5C 249.5,44.5 244.5,44.5 239.5,44.5C 239.5,39.5 239.5,34.5 239.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 254.5,29.5 C 259.5,29.5 264.5,29.5 269.5,29.5C 269.5,34.5 269.5,39.5 269.5,44.5C 264.5,44.5 259.5,44.5 254.5,44.5C 254.5,39.5 254.5,34.5 254.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 269.5,29.5 C 274.5,29.5 279.5,29.5 284.5,29.5C 284.5,34.5 284.5,39.5 284.5,44.5C 279.5,44.5 274.5,44.5 269.5,44.5C 269.5,39.5 269.5,34.5 269.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 629.5,29.5 C 634.5,29.5 639.5,29.5 644.5,29.5C 644.5,34.5 644.5,39.5 644.5,44.5C 639.5,44.5 634.5,44.5 629.5,44.5C 629.5,39.5 629.5,34.5 629.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 644.5,29.5 C 649.5,29.5 654.5,29.5 659.5,29.5C 659.5,34.5 659.5,39.5 659.5,44.5C 654.5,44.5 649.5,44.5 644.5,44.5C 644.5,39.5 644.5,34.5 644.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 659.5,29.5 C 664.5,29.5 669.5,29.5 674.5,29.5C 674.5,34.5 674.5,39.5 674.5,44.5C 669.5,44.5 664.5,44.5 659.5,44.5C 659.5,39.5 659.5,34.5 659.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 674.5,29.5 C 679.5,29.5 684.5,29.5 689.5,29.5C 689.5,34.5 689.5,39.5 689.5,44.5C 684.5,44.5 679.5,44.5 674.5,44.5C 674.5,39.5 674.5,34.5 674.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 689.5,29.5 C 694.5,29.5 699.5,29.5 704.5,29.5C 704.5,34.5 704.5,39.5 704.5,44.5C 699.5,44.5 694.5,44.5 689.5,44.5C 689.5,39.5 689.5,34.5 689.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 704.5,29.5 C 709.5,29.5 714.5,29.5 719.5,29.5C 719.5,34.5 719.5,39.5 719.5,44.5C 714.5,44.5 709.5,44.5 704.5,44.5C 704.5,39.5 704.5,34.5 704.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 719.5,29.5 C 724.5,29.5 729.5,29.5 734.5,29.5C 734.5,34.5 734.5,39.5 734.5,44.5C 729.5,44.5 724.5,44.5 719.5,44.5C 719.5,39.5 719.5,34.5 719.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 734.5,29.5 C 739.5,29.5 744.5,29.5 749.5,29.5C 749.5,34.5 749.5,39.5 749.5,44.5C 744.5,44.5 739.5,44.5 734.5,44.5C 734.5,39.5 734.5,34.5 734.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 749.5,29.5 C 754.5,29.5 759.5,29.5 764.5,29.5C 764.5,34.5 764.5,39.5 764.5,44.5C 759.5,44.5 754.5,44.5 749.5,44.5C 749.5,39.5 749.5,34.5 749.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,29.5 C 769.5,29.5 774.5,29.5 779.5,29.5C 779.5,34.5 779.5,39.5 779.5,44.5C 774.5,44.5 769.5,44.5 764.5,44.5C 764.5,39.5 764.5,34.5 764.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,29.5 C 784.5,29.5 789.5,29.5 794.5,29.5C 794.5,34.5 794.5,39.5 794.5,44.5C 789.5,44.5 784.5,44.5 779.5,44.5C 779.5,39.5 779.5,34.5 779.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,29.5 C 799.5,29.5 804.5,29.5 809.5,29.5C 809.5,34.5 809.5,39.5 809.5,44.5C 804.5,44.5 799.5,44.5 794.5,44.5C 794.5,39.5 794.5,34.5 794.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,29.5 C 814.5,29.5 819.5,29.5 824.5,29.5C 824.5,34.5 824.5,39.5 824.5,44.5C 819.5,44.5 814.5,44.5 809.5,44.5C 809.5,39.5 809.5,34.5 809.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,29.5 C 829.5,29.5 834.5,29.5 839.5,29.5C 839.5,34.5 839.5,39.5 839.5,44.5C 834.5,44.5 829.5,44.5 824.5,44.5C 824.5,39.5 824.5,34.5 824.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,29.5 C 844.5,29.5 849.5,29.5 854.5,29.5C 854.5,34.5 854.5,39.5 854.5,44.5C 849.5,44.5 844.5,44.5 839.5,44.5C 839.5,39.5 839.5,34.5 839.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,29.5 C 859.5,29.5 864.5,29.5 869.5,29.5C 869.5,34.5 869.5,39.5 869.5,44.5C 864.5,44.5 859.5,44.5 854.5,44.5C 854.5,39.5 854.5,34.5 854.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,29.5 C 874.5,29.5 879.5,29.5 884.5,29.5C 884.5,34.5 884.5,39.5 884.5,44.5C 879.5,44.5 874.5,44.5 869.5,44.5C 869.5,39.5 869.5,34.5 869.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,44.5 C 4.5,44.5 9.5,44.5 14.5,44.5C 14.5,49.5 14.5,54.5 14.5,59.5C 9.5,59.5 4.5,59.5 -0.5,59.5C -0.5,54.5 -0.5,49.5 -0.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,44.5 C 19.5,44.5 24.5,44.5 29.5,44.5C 29.5,49.5 29.5,54.5 29.5,59.5C 24.5,59.5 19.5,59.5 14.5,59.5C 14.5,54.5 14.5,49.5 14.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,44.5 C 34.5,44.5 39.5,44.5 44.5,44.5C 44.5,49.5 44.5,54.5 44.5,59.5C 39.5,59.5 34.5,59.5 29.5,59.5C 29.5,54.5 29.5,49.5 29.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,44.5 C 49.5,44.5 54.5,44.5 59.5,44.5C 59.5,49.5 59.5,54.5 59.5,59.5C 54.5,59.5 49.5,59.5 44.5,59.5C 44.5,54.5 44.5,49.5 44.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 59.5,44.5 C 64.5,44.5 69.5,44.5 74.5,44.5C 74.5,49.5 74.5,54.5 74.5,59.5C 69.5,59.5 64.5,59.5 59.5,59.5C 59.5,54.5 59.5,49.5 59.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 74.5,44.5 C 79.5,44.5 84.5,44.5 89.5,44.5C 89.5,49.5 89.5,54.5 89.5,59.5C 84.5,59.5 79.5,59.5 74.5,59.5C 74.5,54.5 74.5,49.5 74.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 89.5,44.5 C 94.5,44.5 99.5,44.5 104.5,44.5C 104.5,49.5 104.5,54.5 104.5,59.5C 99.5,59.5 94.5,59.5 89.5,59.5C 89.5,54.5 89.5,49.5 89.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 104.5,44.5 C 109.5,44.5 114.5,44.5 119.5,44.5C 119.5,49.5 119.5,54.5 119.5,59.5C 114.5,59.5 109.5,59.5 104.5,59.5C 104.5,54.5 104.5,49.5 104.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 119.5,44.5 C 124.5,44.5 129.5,44.5 134.5,44.5C 134.5,49.5 134.5,54.5 134.5,59.5C 129.5,59.5 124.5,59.5 119.5,59.5C 119.5,54.5 119.5,49.5 119.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 134.5,44.5 C 139.5,44.5 144.5,44.5 149.5,44.5C 149.5,49.5 149.5,54.5 149.5,59.5C 144.5,59.5 139.5,59.5 134.5,59.5C 134.5,54.5 134.5,49.5 134.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 149.5,44.5 C 154.5,44.5 159.5,44.5 164.5,44.5C 164.5,49.5 164.5,54.5 164.5,59.5C 159.5,59.5 154.5,59.5 149.5,59.5C 149.5,54.5 149.5,49.5 149.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 164.5,44.5 C 169.5,44.5 174.5,44.5 179.5,44.5C 179.5,49.5 179.5,54.5 179.5,59.5C 174.5,59.5 169.5,59.5 164.5,59.5C 164.5,54.5 164.5,49.5 164.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 179.5,44.5 C 184.5,44.5 189.5,44.5 194.5,44.5C 194.5,49.5 194.5,54.5 194.5,59.5C 189.5,59.5 184.5,59.5 179.5,59.5C 179.5,54.5 179.5,49.5 179.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 194.5,44.5 C 199.5,44.5 204.5,44.5 209.5,44.5C 209.5,49.5 209.5,54.5 209.5,59.5C 204.5,59.5 199.5,59.5 194.5,59.5C 194.5,54.5 194.5,49.5 194.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 209.5,44.5 C 214.5,44.5 219.5,44.5 224.5,44.5C 224.5,49.5 224.5,54.5 224.5,59.5C 219.5,59.5 214.5,59.5 209.5,59.5C 209.5,54.5 209.5,49.5 209.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 224.5,44.5 C 229.5,44.5 234.5,44.5 239.5,44.5C 239.5,49.5 239.5,54.5 239.5,59.5C 234.5,59.5 229.5,59.5 224.5,59.5C 224.5,54.5 224.5,49.5 224.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 239.5,44.5 C 244.5,44.5 249.5,44.5 254.5,44.5C 254.5,49.5 254.5,54.5 254.5,59.5C 249.5,59.5 244.5,59.5 239.5,59.5C 239.5,54.5 239.5,49.5 239.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeaea",
    d: "M 299.5,14.5 C 304.5,14.5 309.5,14.5 314.5,14.5C 314.5,19.5 314.5,24.5 314.5,29.5C 319.5,29.5 324.5,29.5 329.5,29.5C 329.5,24.5 329.5,19.5 329.5,14.5C 334.5,14.5 339.5,14.5 344.5,14.5C 344.5,18.5 344.5,22.5 344.5,26.5C 318.97,34.2616 294.303,44.2616 270.5,56.5C 269.57,52.6002 269.237,48.6002 269.5,44.5C 274.5,44.5 279.5,44.5 284.5,44.5C 284.5,39.5 284.5,34.5 284.5,29.5C 289.5,29.5 294.5,29.5 299.5,29.5C 299.5,24.5 299.5,19.5 299.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 314.5,14.5 C 319.5,14.5 324.5,14.5 329.5,14.5C 329.5,19.5 329.5,24.5 329.5,29.5C 324.5,29.5 319.5,29.5 314.5,29.5C 314.5,24.5 314.5,19.5 314.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeaea",
    d: "M 569.5,14.5 C 574.5,14.5 579.5,14.5 584.5,14.5C 584.5,19.5 584.5,24.5 584.5,29.5C 589.5,29.5 594.5,29.5 599.5,29.5C 599.5,24.5 599.5,19.5 599.5,14.5C 604.5,14.5 609.5,14.5 614.5,14.5C 614.5,19.5 614.5,24.5 614.5,29.5C 619.5,29.5 624.5,29.5 629.5,29.5C 629.5,34.5 629.5,39.5 629.5,44.5C 634.5,44.5 639.5,44.5 644.5,44.5C 644.819,49.3633 644.486,54.03 643.5,58.5C 620.14,46.8158 596.14,36.8158 571.5,28.5C 569.652,24.1464 568.985,19.4797 569.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 584.5,14.5 C 589.5,14.5 594.5,14.5 599.5,14.5C 599.5,19.5 599.5,24.5 599.5,29.5C 594.5,29.5 589.5,29.5 584.5,29.5C 584.5,24.5 584.5,19.5 584.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 659.5,44.5 C 664.5,44.5 669.5,44.5 674.5,44.5C 674.5,49.5 674.5,54.5 674.5,59.5C 669.5,59.5 664.5,59.5 659.5,59.5C 659.5,54.5 659.5,49.5 659.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 674.5,44.5 C 679.5,44.5 684.5,44.5 689.5,44.5C 689.5,49.5 689.5,54.5 689.5,59.5C 684.5,59.5 679.5,59.5 674.5,59.5C 674.5,54.5 674.5,49.5 674.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 689.5,44.5 C 694.5,44.5 699.5,44.5 704.5,44.5C 704.5,49.5 704.5,54.5 704.5,59.5C 699.5,59.5 694.5,59.5 689.5,59.5C 689.5,54.5 689.5,49.5 689.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 704.5,44.5 C 709.5,44.5 714.5,44.5 719.5,44.5C 719.5,49.5 719.5,54.5 719.5,59.5C 714.5,59.5 709.5,59.5 704.5,59.5C 704.5,54.5 704.5,49.5 704.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 719.5,44.5 C 724.5,44.5 729.5,44.5 734.5,44.5C 734.5,49.5 734.5,54.5 734.5,59.5C 729.5,59.5 724.5,59.5 719.5,59.5C 719.5,54.5 719.5,49.5 719.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 734.5,44.5 C 739.5,44.5 744.5,44.5 749.5,44.5C 749.5,49.5 749.5,54.5 749.5,59.5C 744.5,59.5 739.5,59.5 734.5,59.5C 734.5,54.5 734.5,49.5 734.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 749.5,44.5 C 754.5,44.5 759.5,44.5 764.5,44.5C 764.5,49.5 764.5,54.5 764.5,59.5C 759.5,59.5 754.5,59.5 749.5,59.5C 749.5,54.5 749.5,49.5 749.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,44.5 C 769.5,44.5 774.5,44.5 779.5,44.5C 779.5,49.5 779.5,54.5 779.5,59.5C 774.5,59.5 769.5,59.5 764.5,59.5C 764.5,54.5 764.5,49.5 764.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,44.5 C 784.5,44.5 789.5,44.5 794.5,44.5C 794.5,49.5 794.5,54.5 794.5,59.5C 789.5,59.5 784.5,59.5 779.5,59.5C 779.5,54.5 779.5,49.5 779.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,44.5 C 799.5,44.5 804.5,44.5 809.5,44.5C 809.5,49.5 809.5,54.5 809.5,59.5C 804.5,59.5 799.5,59.5 794.5,59.5C 794.5,54.5 794.5,49.5 794.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,44.5 C 814.5,44.5 819.5,44.5 824.5,44.5C 824.5,49.5 824.5,54.5 824.5,59.5C 819.5,59.5 814.5,59.5 809.5,59.5C 809.5,54.5 809.5,49.5 809.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,44.5 C 829.5,44.5 834.5,44.5 839.5,44.5C 839.5,49.5 839.5,54.5 839.5,59.5C 834.5,59.5 829.5,59.5 824.5,59.5C 824.5,54.5 824.5,49.5 824.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,44.5 C 844.5,44.5 849.5,44.5 854.5,44.5C 854.5,49.5 854.5,54.5 854.5,59.5C 849.5,59.5 844.5,59.5 839.5,59.5C 839.5,54.5 839.5,49.5 839.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 854.5,44.5 C 859.5,44.5 864.5,44.5 869.5,44.5C 869.5,49.5 869.5,54.5 869.5,59.5C 864.5,59.5 859.5,59.5 854.5,59.5C 854.5,54.5 854.5,49.5 854.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 869.5,44.5 C 874.5,44.5 879.5,44.5 884.5,44.5C 884.5,49.5 884.5,54.5 884.5,59.5C 879.5,59.5 874.5,59.5 869.5,59.5C 869.5,54.5 869.5,49.5 869.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,59.5 C 4.5,59.5 9.5,59.5 14.5,59.5C 14.5,64.5 14.5,69.5 14.5,74.5C 9.5,74.5 4.5,74.5 -0.5,74.5C -0.5,69.5 -0.5,64.5 -0.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,59.5 C 19.5,59.5 24.5,59.5 29.5,59.5C 29.5,64.5 29.5,69.5 29.5,74.5C 24.5,74.5 19.5,74.5 14.5,74.5C 14.5,69.5 14.5,64.5 14.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,59.5 C 34.5,59.5 39.5,59.5 44.5,59.5C 44.5,64.5 44.5,69.5 44.5,74.5C 39.5,74.5 34.5,74.5 29.5,74.5C 29.5,69.5 29.5,64.5 29.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,59.5 C 49.5,59.5 54.5,59.5 59.5,59.5C 59.5,64.5 59.5,69.5 59.5,74.5C 54.5,74.5 49.5,74.5 44.5,74.5C 44.5,69.5 44.5,64.5 44.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,59.5 C 64.5,59.5 69.5,59.5 74.5,59.5C 74.5,64.5 74.5,69.5 74.5,74.5C 69.5,74.5 64.5,74.5 59.5,74.5C 59.5,69.5 59.5,64.5 59.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 74.5,59.5 C 79.5,59.5 84.5,59.5 89.5,59.5C 89.5,64.5 89.5,69.5 89.5,74.5C 84.5,74.5 79.5,74.5 74.5,74.5C 74.5,69.5 74.5,64.5 74.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 89.5,59.5 C 94.5,59.5 99.5,59.5 104.5,59.5C 104.5,64.5 104.5,69.5 104.5,74.5C 99.5,74.5 94.5,74.5 89.5,74.5C 89.5,69.5 89.5,64.5 89.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 104.5,59.5 C 109.5,59.5 114.5,59.5 119.5,59.5C 119.5,64.5 119.5,69.5 119.5,74.5C 114.5,74.5 109.5,74.5 104.5,74.5C 104.5,69.5 104.5,64.5 104.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,59.5 C 124.5,59.5 129.5,59.5 134.5,59.5C 134.5,64.5 134.5,69.5 134.5,74.5C 129.5,74.5 124.5,74.5 119.5,74.5C 119.5,69.5 119.5,64.5 119.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 134.5,59.5 C 139.5,59.5 144.5,59.5 149.5,59.5C 149.5,64.5 149.5,69.5 149.5,74.5C 144.5,74.5 139.5,74.5 134.5,74.5C 134.5,69.5 134.5,64.5 134.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 149.5,59.5 C 154.5,59.5 159.5,59.5 164.5,59.5C 164.5,64.5 164.5,69.5 164.5,74.5C 159.5,74.5 154.5,74.5 149.5,74.5C 149.5,69.5 149.5,64.5 149.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 164.5,59.5 C 169.5,59.5 174.5,59.5 179.5,59.5C 179.5,64.5 179.5,69.5 179.5,74.5C 174.5,74.5 169.5,74.5 164.5,74.5C 164.5,69.5 164.5,64.5 164.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 179.5,59.5 C 184.5,59.5 189.5,59.5 194.5,59.5C 194.5,64.5 194.5,69.5 194.5,74.5C 189.5,74.5 184.5,74.5 179.5,74.5C 179.5,69.5 179.5,64.5 179.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 194.5,59.5 C 199.5,59.5 204.5,59.5 209.5,59.5C 209.5,64.5 209.5,69.5 209.5,74.5C 204.5,74.5 199.5,74.5 194.5,74.5C 194.5,69.5 194.5,64.5 194.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 209.5,59.5 C 214.5,59.5 219.5,59.5 224.5,59.5C 224.5,64.5 224.5,69.5 224.5,74.5C 219.5,74.5 214.5,74.5 209.5,74.5C 209.5,69.5 209.5,64.5 209.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 224.5,59.5 C 229.5,59.5 234.5,59.5 239.5,59.5C 239.666,64.1785 239.499,68.8452 239,73.5C 234.263,74.4692 229.43,74.8025 224.5,74.5C 224.5,69.5 224.5,64.5 224.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfbfb",
    d: "M 254.5,44.5 C 259.5,44.5 264.5,44.5 269.5,44.5C 269.237,48.6002 269.57,52.6002 270.5,56.5C 254.833,65.3311 239.5,74.6644 224.5,84.5C 224.5,81.1667 224.5,77.8333 224.5,74.5C 229.43,74.8025 234.263,74.4692 239,73.5C 239.499,68.8452 239.666,64.1785 239.5,59.5C 244.5,59.5 249.5,59.5 254.5,59.5C 254.5,54.5 254.5,49.5 254.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfafb",
    d: "M 644.5,44.5 C 649.5,44.5 654.5,44.5 659.5,44.5C 659.5,49.5 659.5,54.5 659.5,59.5C 664.5,59.5 669.5,59.5 674.5,59.5C 674.5,64.5 674.5,69.5 674.5,74.5C 679.5,74.5 684.5,74.5 689.5,74.5C 689.226,79.263 689.559,83.9296 690.5,88.5C 674.995,78.2473 659.328,68.2473 643.5,58.5C 644.486,54.03 644.819,49.3633 644.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 674.5,59.5 C 679.5,59.5 684.5,59.5 689.5,59.5C 689.5,64.5 689.5,69.5 689.5,74.5C 684.5,74.5 679.5,74.5 674.5,74.5C 674.5,69.5 674.5,64.5 674.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 689.5,59.5 C 694.5,59.5 699.5,59.5 704.5,59.5C 704.5,64.5 704.5,69.5 704.5,74.5C 699.5,74.5 694.5,74.5 689.5,74.5C 689.5,69.5 689.5,64.5 689.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 704.5,59.5 C 709.5,59.5 714.5,59.5 719.5,59.5C 719.5,64.5 719.5,69.5 719.5,74.5C 714.5,74.5 709.5,74.5 704.5,74.5C 704.5,69.5 704.5,64.5 704.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 719.5,59.5 C 724.5,59.5 729.5,59.5 734.5,59.5C 734.5,64.5 734.5,69.5 734.5,74.5C 729.5,74.5 724.5,74.5 719.5,74.5C 719.5,69.5 719.5,64.5 719.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 734.5,59.5 C 739.5,59.5 744.5,59.5 749.5,59.5C 749.5,64.5 749.5,69.5 749.5,74.5C 744.5,74.5 739.5,74.5 734.5,74.5C 734.5,69.5 734.5,64.5 734.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 749.5,59.5 C 754.5,59.5 759.5,59.5 764.5,59.5C 764.5,64.5 764.5,69.5 764.5,74.5C 759.5,74.5 754.5,74.5 749.5,74.5C 749.5,69.5 749.5,64.5 749.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,59.5 C 769.5,59.5 774.5,59.5 779.5,59.5C 779.5,64.5 779.5,69.5 779.5,74.5C 774.5,74.5 769.5,74.5 764.5,74.5C 764.5,69.5 764.5,64.5 764.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,59.5 C 784.5,59.5 789.5,59.5 794.5,59.5C 794.5,64.5 794.5,69.5 794.5,74.5C 789.5,74.5 784.5,74.5 779.5,74.5C 779.5,69.5 779.5,64.5 779.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,59.5 C 799.5,59.5 804.5,59.5 809.5,59.5C 809.5,64.5 809.5,69.5 809.5,74.5C 804.5,74.5 799.5,74.5 794.5,74.5C 794.5,69.5 794.5,64.5 794.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,59.5 C 814.5,59.5 819.5,59.5 824.5,59.5C 824.5,64.5 824.5,69.5 824.5,74.5C 819.5,74.5 814.5,74.5 809.5,74.5C 809.5,69.5 809.5,64.5 809.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,59.5 C 829.5,59.5 834.5,59.5 839.5,59.5C 839.5,64.5 839.5,69.5 839.5,74.5C 834.5,74.5 829.5,74.5 824.5,74.5C 824.5,69.5 824.5,64.5 824.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,59.5 C 844.5,59.5 849.5,59.5 854.5,59.5C 854.5,64.5 854.5,69.5 854.5,74.5C 849.5,74.5 844.5,74.5 839.5,74.5C 839.5,69.5 839.5,64.5 839.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,59.5 C 859.5,59.5 864.5,59.5 869.5,59.5C 869.5,64.5 869.5,69.5 869.5,74.5C 864.5,74.5 859.5,74.5 854.5,74.5C 854.5,69.5 854.5,64.5 854.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,59.5 C 874.5,59.5 879.5,59.5 884.5,59.5C 884.5,64.5 884.5,69.5 884.5,74.5C 879.5,74.5 874.5,74.5 869.5,74.5C 869.5,69.5 869.5,64.5 869.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,74.5 C 4.5,74.5 9.5,74.5 14.5,74.5C 14.5,79.5 14.5,84.5 14.5,89.5C 9.5,89.5 4.5,89.5 -0.5,89.5C -0.5,84.5 -0.5,79.5 -0.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,74.5 C 19.5,74.5 24.5,74.5 29.5,74.5C 29.5,79.5 29.5,84.5 29.5,89.5C 24.5,89.5 19.5,89.5 14.5,89.5C 14.5,84.5 14.5,79.5 14.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,74.5 C 34.5,74.5 39.5,74.5 44.5,74.5C 44.5,79.5 44.5,84.5 44.5,89.5C 39.5,89.5 34.5,89.5 29.5,89.5C 29.5,84.5 29.5,79.5 29.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,74.5 C 49.5,74.5 54.5,74.5 59.5,74.5C 59.5,79.5 59.5,84.5 59.5,89.5C 54.5,89.5 49.5,89.5 44.5,89.5C 44.5,84.5 44.5,79.5 44.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 59.5,74.5 C 64.5,74.5 69.5,74.5 74.5,74.5C 74.5,79.5 74.5,84.5 74.5,89.5C 69.5,89.5 64.5,89.5 59.5,89.5C 59.5,84.5 59.5,79.5 59.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 74.5,74.5 C 79.5,74.5 84.5,74.5 89.5,74.5C 89.5,79.5 89.5,84.5 89.5,89.5C 84.5,89.5 79.5,89.5 74.5,89.5C 74.5,84.5 74.5,79.5 74.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 89.5,74.5 C 94.5,74.5 99.5,74.5 104.5,74.5C 104.5,79.5 104.5,84.5 104.5,89.5C 99.5,89.5 94.5,89.5 89.5,89.5C 89.5,84.5 89.5,79.5 89.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 104.5,74.5 C 109.5,74.5 114.5,74.5 119.5,74.5C 119.5,79.5 119.5,84.5 119.5,89.5C 114.5,89.5 109.5,89.5 104.5,89.5C 104.5,84.5 104.5,79.5 104.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 119.5,74.5 C 124.5,74.5 129.5,74.5 134.5,74.5C 134.5,79.5 134.5,84.5 134.5,89.5C 129.5,89.5 124.5,89.5 119.5,89.5C 119.5,84.5 119.5,79.5 119.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 134.5,74.5 C 139.5,74.5 144.5,74.5 149.5,74.5C 149.5,79.5 149.5,84.5 149.5,89.5C 144.5,89.5 139.5,89.5 134.5,89.5C 134.5,84.5 134.5,79.5 134.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 149.5,74.5 C 154.5,74.5 159.5,74.5 164.5,74.5C 164.5,79.5 164.5,84.5 164.5,89.5C 159.5,89.5 154.5,89.5 149.5,89.5C 149.5,84.5 149.5,79.5 149.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 164.5,74.5 C 169.5,74.5 174.5,74.5 179.5,74.5C 179.5,79.5 179.5,84.5 179.5,89.5C 174.5,89.5 169.5,89.5 164.5,89.5C 164.5,84.5 164.5,79.5 164.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 179.5,74.5 C 184.5,74.5 189.5,74.5 194.5,74.5C 194.5,79.5 194.5,84.5 194.5,89.5C 189.5,89.5 184.5,89.5 179.5,89.5C 179.5,84.5 179.5,79.5 179.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 194.5,74.5 C 199.5,74.5 204.5,74.5 209.5,74.5C 209.5,79.5 209.5,84.5 209.5,89.5C 204.5,89.5 199.5,89.5 194.5,89.5C 194.5,84.5 194.5,79.5 194.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 704.5,74.5 C 709.5,74.5 714.5,74.5 719.5,74.5C 719.5,79.5 719.5,84.5 719.5,89.5C 714.5,89.5 709.5,89.5 704.5,89.5C 704.5,84.5 704.5,79.5 704.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 719.5,74.5 C 724.5,74.5 729.5,74.5 734.5,74.5C 734.5,79.5 734.5,84.5 734.5,89.5C 729.5,89.5 724.5,89.5 719.5,89.5C 719.5,84.5 719.5,79.5 719.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 734.5,74.5 C 739.5,74.5 744.5,74.5 749.5,74.5C 749.5,79.5 749.5,84.5 749.5,89.5C 744.5,89.5 739.5,89.5 734.5,89.5C 734.5,84.5 734.5,79.5 734.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 749.5,74.5 C 754.5,74.5 759.5,74.5 764.5,74.5C 764.5,79.5 764.5,84.5 764.5,89.5C 759.5,89.5 754.5,89.5 749.5,89.5C 749.5,84.5 749.5,79.5 749.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,74.5 C 769.5,74.5 774.5,74.5 779.5,74.5C 779.5,79.5 779.5,84.5 779.5,89.5C 774.5,89.5 769.5,89.5 764.5,89.5C 764.5,84.5 764.5,79.5 764.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,74.5 C 784.5,74.5 789.5,74.5 794.5,74.5C 794.5,79.5 794.5,84.5 794.5,89.5C 789.5,89.5 784.5,89.5 779.5,89.5C 779.5,84.5 779.5,79.5 779.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,74.5 C 799.5,74.5 804.5,74.5 809.5,74.5C 809.5,79.5 809.5,84.5 809.5,89.5C 804.5,89.5 799.5,89.5 794.5,89.5C 794.5,84.5 794.5,79.5 794.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,74.5 C 814.5,74.5 819.5,74.5 824.5,74.5C 824.5,79.5 824.5,84.5 824.5,89.5C 819.5,89.5 814.5,89.5 809.5,89.5C 809.5,84.5 809.5,79.5 809.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,74.5 C 829.5,74.5 834.5,74.5 839.5,74.5C 839.5,79.5 839.5,84.5 839.5,89.5C 834.5,89.5 829.5,89.5 824.5,89.5C 824.5,84.5 824.5,79.5 824.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,74.5 C 844.5,74.5 849.5,74.5 854.5,74.5C 854.5,79.5 854.5,84.5 854.5,89.5C 849.5,89.5 844.5,89.5 839.5,89.5C 839.5,84.5 839.5,79.5 839.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 854.5,74.5 C 859.5,74.5 864.5,74.5 869.5,74.5C 869.5,79.5 869.5,84.5 869.5,89.5C 864.5,89.5 859.5,89.5 854.5,89.5C 854.5,84.5 854.5,79.5 854.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 869.5,74.5 C 874.5,74.5 879.5,74.5 884.5,74.5C 884.5,79.5 884.5,84.5 884.5,89.5C 879.5,89.5 874.5,89.5 869.5,89.5C 869.5,84.5 869.5,79.5 869.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,89.5 C 4.5,89.5 9.5,89.5 14.5,89.5C 14.5,94.5 14.5,99.5 14.5,104.5C 9.5,104.5 4.5,104.5 -0.5,104.5C -0.5,99.5 -0.5,94.5 -0.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,89.5 C 19.5,89.5 24.5,89.5 29.5,89.5C 29.5,94.5 29.5,99.5 29.5,104.5C 24.5,104.5 19.5,104.5 14.5,104.5C 14.5,99.5 14.5,94.5 14.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,89.5 C 34.5,89.5 39.5,89.5 44.5,89.5C 44.5,94.5 44.5,99.5 44.5,104.5C 39.5,104.5 34.5,104.5 29.5,104.5C 29.5,99.5 29.5,94.5 29.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,89.5 C 49.5,89.5 54.5,89.5 59.5,89.5C 59.5,94.5 59.5,99.5 59.5,104.5C 54.5,104.5 49.5,104.5 44.5,104.5C 44.5,99.5 44.5,94.5 44.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,89.5 C 64.5,89.5 69.5,89.5 74.5,89.5C 74.5,94.5 74.5,99.5 74.5,104.5C 69.5,104.5 64.5,104.5 59.5,104.5C 59.5,99.5 59.5,94.5 59.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 74.5,89.5 C 79.5,89.5 84.5,89.5 89.5,89.5C 89.5,94.5 89.5,99.5 89.5,104.5C 84.5,104.5 79.5,104.5 74.5,104.5C 74.5,99.5 74.5,94.5 74.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 89.5,89.5 C 94.5,89.5 99.5,89.5 104.5,89.5C 104.5,94.5 104.5,99.5 104.5,104.5C 99.5,104.5 94.5,104.5 89.5,104.5C 89.5,99.5 89.5,94.5 89.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 104.5,89.5 C 109.5,89.5 114.5,89.5 119.5,89.5C 119.5,94.5 119.5,99.5 119.5,104.5C 114.5,104.5 109.5,104.5 104.5,104.5C 104.5,99.5 104.5,94.5 104.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,89.5 C 124.5,89.5 129.5,89.5 134.5,89.5C 134.5,94.5 134.5,99.5 134.5,104.5C 129.5,104.5 124.5,104.5 119.5,104.5C 119.5,99.5 119.5,94.5 119.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 134.5,89.5 C 139.5,89.5 144.5,89.5 149.5,89.5C 149.5,94.5 149.5,99.5 149.5,104.5C 144.5,104.5 139.5,104.5 134.5,104.5C 134.5,99.5 134.5,94.5 134.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 149.5,89.5 C 154.5,89.5 159.5,89.5 164.5,89.5C 164.5,94.5 164.5,99.5 164.5,104.5C 159.5,104.5 154.5,104.5 149.5,104.5C 149.5,99.5 149.5,94.5 149.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 164.5,89.5 C 169.5,89.5 174.5,89.5 179.5,89.5C 179.5,94.5 179.5,99.5 179.5,104.5C 174.5,104.5 169.5,104.5 164.5,104.5C 164.5,99.5 164.5,94.5 164.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 179.5,89.5 C 184.5,89.5 189.5,89.5 194.5,89.5C 194.5,94.5 194.5,99.5 194.5,104.5C 189.5,104.5 184.5,104.5 179.5,104.5C 179.5,99.5 179.5,94.5 179.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 719.5,89.5 C 724.5,89.5 729.5,89.5 734.5,89.5C 734.5,94.5 734.5,99.5 734.5,104.5C 729.5,104.5 724.5,104.5 719.5,104.5C 719.5,99.5 719.5,94.5 719.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 734.5,89.5 C 739.5,89.5 744.5,89.5 749.5,89.5C 749.5,94.5 749.5,99.5 749.5,104.5C 744.5,104.5 739.5,104.5 734.5,104.5C 734.5,99.5 734.5,94.5 734.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 749.5,89.5 C 754.5,89.5 759.5,89.5 764.5,89.5C 764.5,94.5 764.5,99.5 764.5,104.5C 759.5,104.5 754.5,104.5 749.5,104.5C 749.5,99.5 749.5,94.5 749.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,89.5 C 769.5,89.5 774.5,89.5 779.5,89.5C 779.5,94.5 779.5,99.5 779.5,104.5C 774.5,104.5 769.5,104.5 764.5,104.5C 764.5,99.5 764.5,94.5 764.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,89.5 C 784.5,89.5 789.5,89.5 794.5,89.5C 794.5,94.5 794.5,99.5 794.5,104.5C 789.5,104.5 784.5,104.5 779.5,104.5C 779.5,99.5 779.5,94.5 779.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,89.5 C 799.5,89.5 804.5,89.5 809.5,89.5C 809.5,94.5 809.5,99.5 809.5,104.5C 804.5,104.5 799.5,104.5 794.5,104.5C 794.5,99.5 794.5,94.5 794.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,89.5 C 814.5,89.5 819.5,89.5 824.5,89.5C 824.5,94.5 824.5,99.5 824.5,104.5C 819.5,104.5 814.5,104.5 809.5,104.5C 809.5,99.5 809.5,94.5 809.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,89.5 C 829.5,89.5 834.5,89.5 839.5,89.5C 839.5,94.5 839.5,99.5 839.5,104.5C 834.5,104.5 829.5,104.5 824.5,104.5C 824.5,99.5 824.5,94.5 824.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,89.5 C 844.5,89.5 849.5,89.5 854.5,89.5C 854.5,94.5 854.5,99.5 854.5,104.5C 849.5,104.5 844.5,104.5 839.5,104.5C 839.5,99.5 839.5,94.5 839.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,89.5 C 859.5,89.5 864.5,89.5 869.5,89.5C 869.5,94.5 869.5,99.5 869.5,104.5C 864.5,104.5 859.5,104.5 854.5,104.5C 854.5,99.5 854.5,94.5 854.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,89.5 C 874.5,89.5 879.5,89.5 884.5,89.5C 884.5,94.5 884.5,99.5 884.5,104.5C 879.5,104.5 874.5,104.5 869.5,104.5C 869.5,99.5 869.5,94.5 869.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,104.5 C 4.5,104.5 9.5,104.5 14.5,104.5C 14.5,109.5 14.5,114.5 14.5,119.5C 9.5,119.5 4.5,119.5 -0.5,119.5C -0.5,114.5 -0.5,109.5 -0.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,104.5 C 19.5,104.5 24.5,104.5 29.5,104.5C 29.5,109.5 29.5,114.5 29.5,119.5C 24.5,119.5 19.5,119.5 14.5,119.5C 14.5,114.5 14.5,109.5 14.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,104.5 C 34.5,104.5 39.5,104.5 44.5,104.5C 44.5,109.5 44.5,114.5 44.5,119.5C 39.5,119.5 34.5,119.5 29.5,119.5C 29.5,114.5 29.5,109.5 29.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,104.5 C 49.5,104.5 54.5,104.5 59.5,104.5C 59.5,109.5 59.5,114.5 59.5,119.5C 54.5,119.5 49.5,119.5 44.5,119.5C 44.5,114.5 44.5,109.5 44.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 59.5,104.5 C 64.5,104.5 69.5,104.5 74.5,104.5C 74.5,109.5 74.5,114.5 74.5,119.5C 69.5,119.5 64.5,119.5 59.5,119.5C 59.5,114.5 59.5,109.5 59.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 74.5,104.5 C 79.5,104.5 84.5,104.5 89.5,104.5C 89.5,109.5 89.5,114.5 89.5,119.5C 84.5,119.5 79.5,119.5 74.5,119.5C 74.5,114.5 74.5,109.5 74.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 89.5,104.5 C 94.5,104.5 99.5,104.5 104.5,104.5C 104.5,109.5 104.5,114.5 104.5,119.5C 99.5,119.5 94.5,119.5 89.5,119.5C 89.5,114.5 89.5,109.5 89.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 104.5,104.5 C 109.5,104.5 114.5,104.5 119.5,104.5C 119.5,109.5 119.5,114.5 119.5,119.5C 114.5,119.5 109.5,119.5 104.5,119.5C 104.5,114.5 104.5,109.5 104.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 119.5,104.5 C 124.5,104.5 129.5,104.5 134.5,104.5C 134.5,109.5 134.5,114.5 134.5,119.5C 129.5,119.5 124.5,119.5 119.5,119.5C 119.5,114.5 119.5,109.5 119.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 134.5,104.5 C 139.5,104.5 144.5,104.5 149.5,104.5C 149.5,109.5 149.5,114.5 149.5,119.5C 144.5,119.5 139.5,119.5 134.5,119.5C 134.5,114.5 134.5,109.5 134.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 149.5,104.5 C 154.5,104.5 159.5,104.5 164.5,104.5C 164.5,109.5 164.5,114.5 164.5,119.5C 159.5,119.5 154.5,119.5 149.5,119.5C 149.5,114.5 149.5,109.5 149.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 164.5,104.5 C 169.5,104.5 174.5,104.5 179.5,104.5C 179.5,109.5 179.5,114.5 179.5,119.5C 174.5,119.5 169.5,119.5 164.5,119.5C 164.5,114.5 164.5,109.5 164.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e7e7",
    d: "M 209.5,74.5 C 214.5,74.5 219.5,74.5 224.5,74.5C 224.5,77.8333 224.5,81.1667 224.5,84.5C 188.419,111.247 157.419,142.914 131.5,179.5C 127.81,179.383 123.81,179.383 119.5,179.5C 119.5,174.5 119.5,169.5 119.5,164.5C 124.5,164.5 129.5,164.5 134.5,164.5C 134.5,159.5 134.5,154.5 134.5,149.5C 139.5,149.5 144.5,149.5 149.5,149.5C 149.5,144.5 149.5,139.5 149.5,134.5C 154.5,134.5 159.5,134.5 164.5,134.5C 164.5,129.5 164.5,124.5 164.5,119.5C 169.5,119.5 174.5,119.5 179.5,119.5C 179.5,114.5 179.5,109.5 179.5,104.5C 184.5,104.5 189.5,104.5 194.5,104.5C 194.5,99.5 194.5,94.5 194.5,89.5C 199.5,89.5 204.5,89.5 209.5,89.5C 209.5,84.5 209.5,79.5 209.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eaeaea",
    d: "M 689.5,74.5 C 694.5,74.5 699.5,74.5 704.5,74.5C 704.5,79.5 704.5,84.5 704.5,89.5C 709.5,89.5 714.5,89.5 719.5,89.5C 719.5,94.5 719.5,99.5 719.5,104.5C 724.5,104.5 729.5,104.5 734.5,104.5C 734.5,109.5 734.5,114.5 734.5,119.5C 739.5,119.5 744.5,119.5 749.5,119.5C 749.5,124.5 749.5,129.5 749.5,134.5C 754.5,134.5 759.5,134.5 764.5,134.5C 764.5,139.5 764.5,144.5 764.5,149.5C 769.5,149.5 774.5,149.5 779.5,149.5C 779.5,154.5 779.5,159.5 779.5,164.5C 775.298,164.183 771.298,164.517 767.5,165.5C 744.833,136.833 719.167,111.167 690.5,88.5C 689.559,83.9296 689.226,79.263 689.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 734.5,104.5 C 739.5,104.5 744.5,104.5 749.5,104.5C 749.5,109.5 749.5,114.5 749.5,119.5C 744.5,119.5 739.5,119.5 734.5,119.5C 734.5,114.5 734.5,109.5 734.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 749.5,104.5 C 754.5,104.5 759.5,104.5 764.5,104.5C 764.5,109.5 764.5,114.5 764.5,119.5C 759.5,119.5 754.5,119.5 749.5,119.5C 749.5,114.5 749.5,109.5 749.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,104.5 C 769.5,104.5 774.5,104.5 779.5,104.5C 779.5,109.5 779.5,114.5 779.5,119.5C 774.5,119.5 769.5,119.5 764.5,119.5C 764.5,114.5 764.5,109.5 764.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,104.5 C 784.5,104.5 789.5,104.5 794.5,104.5C 794.5,109.5 794.5,114.5 794.5,119.5C 789.5,119.5 784.5,119.5 779.5,119.5C 779.5,114.5 779.5,109.5 779.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,104.5 C 799.5,104.5 804.5,104.5 809.5,104.5C 809.5,109.5 809.5,114.5 809.5,119.5C 804.5,119.5 799.5,119.5 794.5,119.5C 794.5,114.5 794.5,109.5 794.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,104.5 C 814.5,104.5 819.5,104.5 824.5,104.5C 824.5,109.5 824.5,114.5 824.5,119.5C 819.5,119.5 814.5,119.5 809.5,119.5C 809.5,114.5 809.5,109.5 809.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,104.5 C 829.5,104.5 834.5,104.5 839.5,104.5C 839.5,109.5 839.5,114.5 839.5,119.5C 834.5,119.5 829.5,119.5 824.5,119.5C 824.5,114.5 824.5,109.5 824.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,104.5 C 844.5,104.5 849.5,104.5 854.5,104.5C 854.5,109.5 854.5,114.5 854.5,119.5C 849.5,119.5 844.5,119.5 839.5,119.5C 839.5,114.5 839.5,109.5 839.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 854.5,104.5 C 859.5,104.5 864.5,104.5 869.5,104.5C 869.5,109.5 869.5,114.5 869.5,119.5C 864.5,119.5 859.5,119.5 854.5,119.5C 854.5,114.5 854.5,109.5 854.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 869.5,104.5 C 874.5,104.5 879.5,104.5 884.5,104.5C 884.5,109.5 884.5,114.5 884.5,119.5C 879.5,119.5 874.5,119.5 869.5,119.5C 869.5,114.5 869.5,109.5 869.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,119.5 C 4.5,119.5 9.5,119.5 14.5,119.5C 14.5,124.5 14.5,129.5 14.5,134.5C 9.5,134.5 4.5,134.5 -0.5,134.5C -0.5,129.5 -0.5,124.5 -0.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,119.5 C 19.5,119.5 24.5,119.5 29.5,119.5C 29.5,124.5 29.5,129.5 29.5,134.5C 24.5,134.5 19.5,134.5 14.5,134.5C 14.5,129.5 14.5,124.5 14.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,119.5 C 34.5,119.5 39.5,119.5 44.5,119.5C 44.5,124.5 44.5,129.5 44.5,134.5C 39.5,134.5 34.5,134.5 29.5,134.5C 29.5,129.5 29.5,124.5 29.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,119.5 C 49.5,119.5 54.5,119.5 59.5,119.5C 59.5,124.5 59.5,129.5 59.5,134.5C 54.5,134.5 49.5,134.5 44.5,134.5C 44.5,129.5 44.5,124.5 44.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,119.5 C 64.5,119.5 69.5,119.5 74.5,119.5C 74.5,124.5 74.5,129.5 74.5,134.5C 69.5,134.5 64.5,134.5 59.5,134.5C 59.5,129.5 59.5,124.5 59.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 74.5,119.5 C 79.5,119.5 84.5,119.5 89.5,119.5C 89.5,124.5 89.5,129.5 89.5,134.5C 84.5,134.5 79.5,134.5 74.5,134.5C 74.5,129.5 74.5,124.5 74.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 89.5,119.5 C 94.5,119.5 99.5,119.5 104.5,119.5C 104.5,124.5 104.5,129.5 104.5,134.5C 99.5,134.5 94.5,134.5 89.5,134.5C 89.5,129.5 89.5,124.5 89.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 104.5,119.5 C 109.5,119.5 114.5,119.5 119.5,119.5C 119.5,124.5 119.5,129.5 119.5,134.5C 114.5,134.5 109.5,134.5 104.5,134.5C 104.5,129.5 104.5,124.5 104.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,119.5 C 124.5,119.5 129.5,119.5 134.5,119.5C 134.5,124.5 134.5,129.5 134.5,134.5C 129.5,134.5 124.5,134.5 119.5,134.5C 119.5,129.5 119.5,124.5 119.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 134.5,119.5 C 139.5,119.5 144.5,119.5 149.5,119.5C 149.5,124.5 149.5,129.5 149.5,134.5C 144.5,134.5 139.5,134.5 134.5,134.5C 134.5,129.5 134.5,124.5 134.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 149.5,119.5 C 154.5,119.5 159.5,119.5 164.5,119.5C 164.5,124.5 164.5,129.5 164.5,134.5C 159.5,134.5 154.5,134.5 149.5,134.5C 149.5,129.5 149.5,124.5 149.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 749.5,119.5 C 754.5,119.5 759.5,119.5 764.5,119.5C 764.5,124.5 764.5,129.5 764.5,134.5C 759.5,134.5 754.5,134.5 749.5,134.5C 749.5,129.5 749.5,124.5 749.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,119.5 C 769.5,119.5 774.5,119.5 779.5,119.5C 779.5,124.5 779.5,129.5 779.5,134.5C 774.5,134.5 769.5,134.5 764.5,134.5C 764.5,129.5 764.5,124.5 764.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,119.5 C 784.5,119.5 789.5,119.5 794.5,119.5C 794.5,124.5 794.5,129.5 794.5,134.5C 789.5,134.5 784.5,134.5 779.5,134.5C 779.5,129.5 779.5,124.5 779.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,119.5 C 799.5,119.5 804.5,119.5 809.5,119.5C 809.5,124.5 809.5,129.5 809.5,134.5C 804.5,134.5 799.5,134.5 794.5,134.5C 794.5,129.5 794.5,124.5 794.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,119.5 C 814.5,119.5 819.5,119.5 824.5,119.5C 824.5,124.5 824.5,129.5 824.5,134.5C 819.5,134.5 814.5,134.5 809.5,134.5C 809.5,129.5 809.5,124.5 809.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,119.5 C 829.5,119.5 834.5,119.5 839.5,119.5C 839.5,124.5 839.5,129.5 839.5,134.5C 834.5,134.5 829.5,134.5 824.5,134.5C 824.5,129.5 824.5,124.5 824.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,119.5 C 844.5,119.5 849.5,119.5 854.5,119.5C 854.5,124.5 854.5,129.5 854.5,134.5C 849.5,134.5 844.5,134.5 839.5,134.5C 839.5,129.5 839.5,124.5 839.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,119.5 C 859.5,119.5 864.5,119.5 869.5,119.5C 869.5,124.5 869.5,129.5 869.5,134.5C 864.5,134.5 859.5,134.5 854.5,134.5C 854.5,129.5 854.5,124.5 854.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,119.5 C 874.5,119.5 879.5,119.5 884.5,119.5C 884.5,124.5 884.5,129.5 884.5,134.5C 879.5,134.5 874.5,134.5 869.5,134.5C 869.5,129.5 869.5,124.5 869.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,134.5 C 4.5,134.5 9.5,134.5 14.5,134.5C 14.5,139.5 14.5,144.5 14.5,149.5C 9.5,149.5 4.5,149.5 -0.5,149.5C -0.5,144.5 -0.5,139.5 -0.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,134.5 C 19.5,134.5 24.5,134.5 29.5,134.5C 29.5,139.5 29.5,144.5 29.5,149.5C 24.5,149.5 19.5,149.5 14.5,149.5C 14.5,144.5 14.5,139.5 14.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,134.5 C 34.5,134.5 39.5,134.5 44.5,134.5C 44.5,139.5 44.5,144.5 44.5,149.5C 39.5,149.5 34.5,149.5 29.5,149.5C 29.5,144.5 29.5,139.5 29.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,134.5 C 49.5,134.5 54.5,134.5 59.5,134.5C 59.5,139.5 59.5,144.5 59.5,149.5C 54.5,149.5 49.5,149.5 44.5,149.5C 44.5,144.5 44.5,139.5 44.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 59.5,134.5 C 64.5,134.5 69.5,134.5 74.5,134.5C 74.5,139.5 74.5,144.5 74.5,149.5C 69.5,149.5 64.5,149.5 59.5,149.5C 59.5,144.5 59.5,139.5 59.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 74.5,134.5 C 79.5,134.5 84.5,134.5 89.5,134.5C 89.5,139.5 89.5,144.5 89.5,149.5C 84.5,149.5 79.5,149.5 74.5,149.5C 74.5,144.5 74.5,139.5 74.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 89.5,134.5 C 94.5,134.5 99.5,134.5 104.5,134.5C 104.5,139.5 104.5,144.5 104.5,149.5C 99.5,149.5 94.5,149.5 89.5,149.5C 89.5,144.5 89.5,139.5 89.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 104.5,134.5 C 109.5,134.5 114.5,134.5 119.5,134.5C 119.5,139.5 119.5,144.5 119.5,149.5C 114.5,149.5 109.5,149.5 104.5,149.5C 104.5,144.5 104.5,139.5 104.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 119.5,134.5 C 124.5,134.5 129.5,134.5 134.5,134.5C 134.5,139.5 134.5,144.5 134.5,149.5C 129.5,149.5 124.5,149.5 119.5,149.5C 119.5,144.5 119.5,139.5 119.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 134.5,134.5 C 139.5,134.5 144.5,134.5 149.5,134.5C 149.5,139.5 149.5,144.5 149.5,149.5C 144.5,149.5 139.5,149.5 134.5,149.5C 134.5,144.5 134.5,139.5 134.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,134.5 C 769.5,134.5 774.5,134.5 779.5,134.5C 779.5,139.5 779.5,144.5 779.5,149.5C 774.5,149.5 769.5,149.5 764.5,149.5C 764.5,144.5 764.5,139.5 764.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,134.5 C 784.5,134.5 789.5,134.5 794.5,134.5C 794.5,139.5 794.5,144.5 794.5,149.5C 789.5,149.5 784.5,149.5 779.5,149.5C 779.5,144.5 779.5,139.5 779.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,134.5 C 799.5,134.5 804.5,134.5 809.5,134.5C 809.5,139.5 809.5,144.5 809.5,149.5C 804.5,149.5 799.5,149.5 794.5,149.5C 794.5,144.5 794.5,139.5 794.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,134.5 C 814.5,134.5 819.5,134.5 824.5,134.5C 824.5,139.5 824.5,144.5 824.5,149.5C 819.5,149.5 814.5,149.5 809.5,149.5C 809.5,144.5 809.5,139.5 809.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,134.5 C 829.5,134.5 834.5,134.5 839.5,134.5C 839.5,139.5 839.5,144.5 839.5,149.5C 834.5,149.5 829.5,149.5 824.5,149.5C 824.5,144.5 824.5,139.5 824.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,134.5 C 844.5,134.5 849.5,134.5 854.5,134.5C 854.5,139.5 854.5,144.5 854.5,149.5C 849.5,149.5 844.5,149.5 839.5,149.5C 839.5,144.5 839.5,139.5 839.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 854.5,134.5 C 859.5,134.5 864.5,134.5 869.5,134.5C 869.5,139.5 869.5,144.5 869.5,149.5C 864.5,149.5 859.5,149.5 854.5,149.5C 854.5,144.5 854.5,139.5 854.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 869.5,134.5 C 874.5,134.5 879.5,134.5 884.5,134.5C 884.5,139.5 884.5,144.5 884.5,149.5C 879.5,149.5 874.5,149.5 869.5,149.5C 869.5,144.5 869.5,139.5 869.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,149.5 C 4.5,149.5 9.5,149.5 14.5,149.5C 14.5,154.5 14.5,159.5 14.5,164.5C 9.5,164.5 4.5,164.5 -0.5,164.5C -0.5,159.5 -0.5,154.5 -0.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,149.5 C 19.5,149.5 24.5,149.5 29.5,149.5C 29.5,154.5 29.5,159.5 29.5,164.5C 24.5,164.5 19.5,164.5 14.5,164.5C 14.5,159.5 14.5,154.5 14.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,149.5 C 34.5,149.5 39.5,149.5 44.5,149.5C 44.5,154.5 44.5,159.5 44.5,164.5C 39.5,164.5 34.5,164.5 29.5,164.5C 29.5,159.5 29.5,154.5 29.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,149.5 C 49.5,149.5 54.5,149.5 59.5,149.5C 59.5,154.5 59.5,159.5 59.5,164.5C 54.5,164.5 49.5,164.5 44.5,164.5C 44.5,159.5 44.5,154.5 44.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,149.5 C 64.5,149.5 69.5,149.5 74.5,149.5C 74.5,154.5 74.5,159.5 74.5,164.5C 69.5,164.5 64.5,164.5 59.5,164.5C 59.5,159.5 59.5,154.5 59.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 74.5,149.5 C 79.5,149.5 84.5,149.5 89.5,149.5C 89.5,154.5 89.5,159.5 89.5,164.5C 84.5,164.5 79.5,164.5 74.5,164.5C 74.5,159.5 74.5,154.5 74.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 89.5,149.5 C 94.5,149.5 99.5,149.5 104.5,149.5C 104.5,154.5 104.5,159.5 104.5,164.5C 99.5,164.5 94.5,164.5 89.5,164.5C 89.5,159.5 89.5,154.5 89.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 104.5,149.5 C 109.5,149.5 114.5,149.5 119.5,149.5C 119.5,154.5 119.5,159.5 119.5,164.5C 114.5,164.5 109.5,164.5 104.5,164.5C 104.5,159.5 104.5,154.5 104.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 119.5,149.5 C 124.5,149.5 129.5,149.5 134.5,149.5C 134.5,154.5 134.5,159.5 134.5,164.5C 129.5,164.5 124.5,164.5 119.5,164.5C 119.5,159.5 119.5,154.5 119.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,149.5 C 784.5,149.5 789.5,149.5 794.5,149.5C 794.5,154.5 794.5,159.5 794.5,164.5C 789.5,164.5 784.5,164.5 779.5,164.5C 779.5,159.5 779.5,154.5 779.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,149.5 C 799.5,149.5 804.5,149.5 809.5,149.5C 809.5,154.5 809.5,159.5 809.5,164.5C 804.5,164.5 799.5,164.5 794.5,164.5C 794.5,159.5 794.5,154.5 794.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,149.5 C 814.5,149.5 819.5,149.5 824.5,149.5C 824.5,154.5 824.5,159.5 824.5,164.5C 819.5,164.5 814.5,164.5 809.5,164.5C 809.5,159.5 809.5,154.5 809.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,149.5 C 829.5,149.5 834.5,149.5 839.5,149.5C 839.5,154.5 839.5,159.5 839.5,164.5C 834.5,164.5 829.5,164.5 824.5,164.5C 824.5,159.5 824.5,154.5 824.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,149.5 C 844.5,149.5 849.5,149.5 854.5,149.5C 854.5,154.5 854.5,159.5 854.5,164.5C 849.5,164.5 844.5,164.5 839.5,164.5C 839.5,159.5 839.5,154.5 839.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,149.5 C 859.5,149.5 864.5,149.5 869.5,149.5C 869.5,154.5 869.5,159.5 869.5,164.5C 864.5,164.5 859.5,164.5 854.5,164.5C 854.5,159.5 854.5,154.5 854.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,149.5 C 874.5,149.5 879.5,149.5 884.5,149.5C 884.5,154.5 884.5,159.5 884.5,164.5C 879.5,164.5 874.5,164.5 869.5,164.5C 869.5,159.5 869.5,154.5 869.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,164.5 C 4.5,164.5 9.5,164.5 14.5,164.5C 14.5,169.5 14.5,174.5 14.5,179.5C 9.5,179.5 4.5,179.5 -0.5,179.5C -0.5,174.5 -0.5,169.5 -0.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,164.5 C 19.5,164.5 24.5,164.5 29.5,164.5C 29.5,169.5 29.5,174.5 29.5,179.5C 24.5,179.5 19.5,179.5 14.5,179.5C 14.5,174.5 14.5,169.5 14.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,164.5 C 34.5,164.5 39.5,164.5 44.5,164.5C 44.5,169.5 44.5,174.5 44.5,179.5C 39.5,179.5 34.5,179.5 29.5,179.5C 29.5,174.5 29.5,169.5 29.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,164.5 C 49.5,164.5 54.5,164.5 59.5,164.5C 59.5,169.5 59.5,174.5 59.5,179.5C 54.5,179.5 49.5,179.5 44.5,179.5C 44.5,174.5 44.5,169.5 44.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 59.5,164.5 C 64.5,164.5 69.5,164.5 74.5,164.5C 74.5,169.5 74.5,174.5 74.5,179.5C 69.5,179.5 64.5,179.5 59.5,179.5C 59.5,174.5 59.5,169.5 59.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 74.5,164.5 C 79.5,164.5 84.5,164.5 89.5,164.5C 89.5,169.5 89.5,174.5 89.5,179.5C 84.5,179.5 79.5,179.5 74.5,179.5C 74.5,174.5 74.5,169.5 74.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 89.5,164.5 C 94.5,164.5 99.5,164.5 104.5,164.5C 104.5,169.5 104.5,174.5 104.5,179.5C 99.5,179.5 94.5,179.5 89.5,179.5C 89.5,174.5 89.5,169.5 89.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 104.5,164.5 C 109.5,164.5 114.5,164.5 119.5,164.5C 119.5,169.5 119.5,174.5 119.5,179.5C 114.5,179.5 109.5,179.5 104.5,179.5C 104.5,174.5 104.5,169.5 104.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,164.5 C 784.5,164.5 789.5,164.5 794.5,164.5C 794.5,169.5 794.5,174.5 794.5,179.5C 789.5,179.5 784.5,179.5 779.5,179.5C 779.5,174.5 779.5,169.5 779.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,164.5 C 799.5,164.5 804.5,164.5 809.5,164.5C 809.5,169.5 809.5,174.5 809.5,179.5C 804.5,179.5 799.5,179.5 794.5,179.5C 794.5,174.5 794.5,169.5 794.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,164.5 C 814.5,164.5 819.5,164.5 824.5,164.5C 824.5,169.5 824.5,174.5 824.5,179.5C 819.5,179.5 814.5,179.5 809.5,179.5C 809.5,174.5 809.5,169.5 809.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,164.5 C 829.5,164.5 834.5,164.5 839.5,164.5C 839.5,169.5 839.5,174.5 839.5,179.5C 834.5,179.5 829.5,179.5 824.5,179.5C 824.5,174.5 824.5,169.5 824.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,164.5 C 844.5,164.5 849.5,164.5 854.5,164.5C 854.5,169.5 854.5,174.5 854.5,179.5C 849.5,179.5 844.5,179.5 839.5,179.5C 839.5,174.5 839.5,169.5 839.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 854.5,164.5 C 859.5,164.5 864.5,164.5 869.5,164.5C 869.5,169.5 869.5,174.5 869.5,179.5C 864.5,179.5 859.5,179.5 854.5,179.5C 854.5,174.5 854.5,169.5 854.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 869.5,164.5 C 874.5,164.5 879.5,164.5 884.5,164.5C 884.5,169.5 884.5,174.5 884.5,179.5C 879.5,179.5 874.5,179.5 869.5,179.5C 869.5,174.5 869.5,169.5 869.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,179.5 C 4.5,179.5 9.5,179.5 14.5,179.5C 14.5,184.5 14.5,189.5 14.5,194.5C 9.5,194.5 4.5,194.5 -0.5,194.5C -0.5,189.5 -0.5,184.5 -0.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,179.5 C 19.5,179.5 24.5,179.5 29.5,179.5C 29.5,184.5 29.5,189.5 29.5,194.5C 24.5,194.5 19.5,194.5 14.5,194.5C 14.5,189.5 14.5,184.5 14.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,179.5 C 34.5,179.5 39.5,179.5 44.5,179.5C 44.5,184.5 44.5,189.5 44.5,194.5C 39.5,194.5 34.5,194.5 29.5,194.5C 29.5,189.5 29.5,184.5 29.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,179.5 C 49.5,179.5 54.5,179.5 59.5,179.5C 59.5,184.5 59.5,189.5 59.5,194.5C 54.5,194.5 49.5,194.5 44.5,194.5C 44.5,189.5 44.5,184.5 44.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,179.5 C 64.5,179.5 69.5,179.5 74.5,179.5C 74.5,184.5 74.5,189.5 74.5,194.5C 69.5,194.5 64.5,194.5 59.5,194.5C 59.5,189.5 59.5,184.5 59.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 74.5,179.5 C 79.5,179.5 84.5,179.5 89.5,179.5C 89.5,184.5 89.5,189.5 89.5,194.5C 84.5,194.5 79.5,194.5 74.5,194.5C 74.5,189.5 74.5,184.5 74.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 89.5,179.5 C 94.5,179.5 99.5,179.5 104.5,179.5C 104.5,184.5 104.5,189.5 104.5,194.5C 99.5,194.5 94.5,194.5 89.5,194.5C 89.5,189.5 89.5,184.5 89.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 104.5,179.5 C 109.5,179.5 114.5,179.5 119.5,179.5C 119.5,184.5 119.5,189.5 119.5,194.5C 114.5,194.5 109.5,194.5 104.5,194.5C 104.5,189.5 104.5,184.5 104.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,179.5 C 799.5,179.5 804.5,179.5 809.5,179.5C 809.5,184.5 809.5,189.5 809.5,194.5C 804.5,194.5 799.5,194.5 794.5,194.5C 794.5,189.5 794.5,184.5 794.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,179.5 C 814.5,179.5 819.5,179.5 824.5,179.5C 824.5,184.5 824.5,189.5 824.5,194.5C 819.5,194.5 814.5,194.5 809.5,194.5C 809.5,189.5 809.5,184.5 809.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,179.5 C 829.5,179.5 834.5,179.5 839.5,179.5C 839.5,184.5 839.5,189.5 839.5,194.5C 834.5,194.5 829.5,194.5 824.5,194.5C 824.5,189.5 824.5,184.5 824.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,179.5 C 844.5,179.5 849.5,179.5 854.5,179.5C 854.5,184.5 854.5,189.5 854.5,194.5C 849.5,194.5 844.5,194.5 839.5,194.5C 839.5,189.5 839.5,184.5 839.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,179.5 C 859.5,179.5 864.5,179.5 869.5,179.5C 869.5,184.5 869.5,189.5 869.5,194.5C 864.5,194.5 859.5,194.5 854.5,194.5C 854.5,189.5 854.5,184.5 854.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,179.5 C 874.5,179.5 879.5,179.5 884.5,179.5C 884.5,184.5 884.5,189.5 884.5,194.5C 879.5,194.5 874.5,194.5 869.5,194.5C 869.5,189.5 869.5,184.5 869.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,194.5 C 4.5,194.5 9.5,194.5 14.5,194.5C 14.5,199.5 14.5,204.5 14.5,209.5C 9.5,209.5 4.5,209.5 -0.5,209.5C -0.5,204.5 -0.5,199.5 -0.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,194.5 C 19.5,194.5 24.5,194.5 29.5,194.5C 29.5,199.5 29.5,204.5 29.5,209.5C 24.5,209.5 19.5,209.5 14.5,209.5C 14.5,204.5 14.5,199.5 14.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,194.5 C 34.5,194.5 39.5,194.5 44.5,194.5C 44.5,199.5 44.5,204.5 44.5,209.5C 39.5,209.5 34.5,209.5 29.5,209.5C 29.5,204.5 29.5,199.5 29.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,194.5 C 49.5,194.5 54.5,194.5 59.5,194.5C 59.5,199.5 59.5,204.5 59.5,209.5C 54.5,209.5 49.5,209.5 44.5,209.5C 44.5,204.5 44.5,199.5 44.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 59.5,194.5 C 64.5,194.5 69.5,194.5 74.5,194.5C 74.5,199.5 74.5,204.5 74.5,209.5C 69.5,209.5 64.5,209.5 59.5,209.5C 59.5,204.5 59.5,199.5 59.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 74.5,194.5 C 79.5,194.5 84.5,194.5 89.5,194.5C 89.5,199.5 89.5,204.5 89.5,209.5C 84.5,209.5 79.5,209.5 74.5,209.5C 74.5,204.5 74.5,199.5 74.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 89.5,194.5 C 94.5,194.5 99.5,194.5 104.5,194.5C 104.5,199.5 104.5,204.5 104.5,209.5C 99.5,209.5 94.5,209.5 89.5,209.5C 89.5,204.5 89.5,199.5 89.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 779.5,164.5 C 779.5,169.5 779.5,174.5 779.5,179.5C 784.5,179.5 789.5,179.5 794.5,179.5C 794.5,184.5 794.5,189.5 794.5,194.5C 799.5,194.5 804.5,194.5 809.5,194.5C 809.5,199.5 809.5,204.5 809.5,209.5C 805.167,209.5 800.833,209.5 796.5,209.5C 787.619,194.291 777.952,179.625 767.5,165.5C 771.298,164.517 775.298,164.183 779.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,194.5 C 814.5,194.5 819.5,194.5 824.5,194.5C 824.5,199.5 824.5,204.5 824.5,209.5C 819.5,209.5 814.5,209.5 809.5,209.5C 809.5,204.5 809.5,199.5 809.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,194.5 C 829.5,194.5 834.5,194.5 839.5,194.5C 839.5,199.5 839.5,204.5 839.5,209.5C 834.5,209.5 829.5,209.5 824.5,209.5C 824.5,204.5 824.5,199.5 824.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,194.5 C 844.5,194.5 849.5,194.5 854.5,194.5C 854.5,199.5 854.5,204.5 854.5,209.5C 849.5,209.5 844.5,209.5 839.5,209.5C 839.5,204.5 839.5,199.5 839.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 854.5,194.5 C 859.5,194.5 864.5,194.5 869.5,194.5C 869.5,199.5 869.5,204.5 869.5,209.5C 864.5,209.5 859.5,209.5 854.5,209.5C 854.5,204.5 854.5,199.5 854.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 869.5,194.5 C 874.5,194.5 879.5,194.5 884.5,194.5C 884.5,199.5 884.5,204.5 884.5,209.5C 879.5,209.5 874.5,209.5 869.5,209.5C 869.5,204.5 869.5,199.5 869.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,209.5 C 4.5,209.5 9.5,209.5 14.5,209.5C 14.5,214.5 14.5,219.5 14.5,224.5C 9.5,224.5 4.5,224.5 -0.5,224.5C -0.5,219.5 -0.5,214.5 -0.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,209.5 C 19.5,209.5 24.5,209.5 29.5,209.5C 29.5,214.5 29.5,219.5 29.5,224.5C 24.5,224.5 19.5,224.5 14.5,224.5C 14.5,219.5 14.5,214.5 14.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,209.5 C 34.5,209.5 39.5,209.5 44.5,209.5C 44.5,214.5 44.5,219.5 44.5,224.5C 39.5,224.5 34.5,224.5 29.5,224.5C 29.5,219.5 29.5,214.5 29.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,209.5 C 49.5,209.5 54.5,209.5 59.5,209.5C 59.5,214.5 59.5,219.5 59.5,224.5C 54.5,224.5 49.5,224.5 44.5,224.5C 44.5,219.5 44.5,214.5 44.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,209.5 C 64.5,209.5 69.5,209.5 74.5,209.5C 74.5,214.5 74.5,219.5 74.5,224.5C 69.5,224.5 64.5,224.5 59.5,224.5C 59.5,219.5 59.5,214.5 59.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 74.5,209.5 C 79.5,209.5 84.5,209.5 89.5,209.5C 89.5,214.5 89.5,219.5 89.5,224.5C 84.5,224.5 79.5,224.5 74.5,224.5C 74.5,219.5 74.5,214.5 74.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,209.5 C 814.5,209.5 819.5,209.5 824.5,209.5C 824.5,214.5 824.5,219.5 824.5,224.5C 819.5,224.5 814.5,224.5 809.5,224.5C 809.5,219.5 809.5,214.5 809.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,209.5 C 829.5,209.5 834.5,209.5 839.5,209.5C 839.5,214.5 839.5,219.5 839.5,224.5C 834.5,224.5 829.5,224.5 824.5,224.5C 824.5,219.5 824.5,214.5 824.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,209.5 C 844.5,209.5 849.5,209.5 854.5,209.5C 854.5,214.5 854.5,219.5 854.5,224.5C 849.5,224.5 844.5,224.5 839.5,224.5C 839.5,219.5 839.5,214.5 839.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,209.5 C 859.5,209.5 864.5,209.5 869.5,209.5C 869.5,214.5 869.5,219.5 869.5,224.5C 864.5,224.5 859.5,224.5 854.5,224.5C 854.5,219.5 854.5,214.5 854.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,209.5 C 874.5,209.5 879.5,209.5 884.5,209.5C 884.5,214.5 884.5,219.5 884.5,224.5C 879.5,224.5 874.5,224.5 869.5,224.5C 869.5,219.5 869.5,214.5 869.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,224.5 C 4.5,224.5 9.5,224.5 14.5,224.5C 14.5,229.5 14.5,234.5 14.5,239.5C 9.5,239.5 4.5,239.5 -0.5,239.5C -0.5,234.5 -0.5,229.5 -0.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,224.5 C 19.5,224.5 24.5,224.5 29.5,224.5C 29.5,229.5 29.5,234.5 29.5,239.5C 24.5,239.5 19.5,239.5 14.5,239.5C 14.5,234.5 14.5,229.5 14.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,224.5 C 34.5,224.5 39.5,224.5 44.5,224.5C 44.5,229.5 44.5,234.5 44.5,239.5C 39.5,239.5 34.5,239.5 29.5,239.5C 29.5,234.5 29.5,229.5 29.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,224.5 C 49.5,224.5 54.5,224.5 59.5,224.5C 59.5,229.5 59.5,234.5 59.5,239.5C 54.5,239.5 49.5,239.5 44.5,239.5C 44.5,234.5 44.5,229.5 44.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 59.5,224.5 C 64.5,224.5 69.5,224.5 74.5,224.5C 74.5,229.5 74.5,234.5 74.5,239.5C 69.5,239.5 64.5,239.5 59.5,239.5C 59.5,234.5 59.5,229.5 59.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 329.5,253.5 C 336.17,272.512 342.837,291.512 349.5,310.5C 359.833,310.5 370.167,310.5 380.5,310.5C 474.495,309.39 568.495,309.223 662.5,310C 665.576,311.243 668.243,313.077 670.5,315.5C 671.376,318.799 671.543,322.132 671,325.5C 654.512,377.12 638.179,428.786 622,480.5C 620.073,485.428 616.573,488.594 611.5,490C 538.472,490.824 465.472,490.657 392.5,489.5C 388.817,487.17 386.317,483.837 385,479.5C 364.453,422.023 343.62,364.69 322.5,307.5C 318.328,294.482 313.661,281.649 308.5,269C 282.945,261.695 257.278,254.861 231.5,248.5C 222.677,241.403 222.343,233.903 230.5,226C 232.366,225.015 234.366,224.515 236.5,224.5C 265.997,231.708 295.33,239.541 324.5,248C 326.402,249.73 328.069,251.563 329.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7e7e7",
    d: "M 796.5,209.5 C 800.833,209.5 805.167,209.5 809.5,209.5C 809.5,214.5 809.5,219.5 809.5,224.5C 814.5,224.5 819.5,224.5 824.5,224.5C 824.5,229.5 824.5,234.5 824.5,239.5C 819.847,240.001 815.514,239.334 811.5,237.5C 806.516,228.201 801.516,218.868 796.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,224.5 C 829.5,224.5 834.5,224.5 839.5,224.5C 839.5,229.5 839.5,234.5 839.5,239.5C 834.5,239.5 829.5,239.5 824.5,239.5C 824.5,234.5 824.5,229.5 824.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,224.5 C 844.5,224.5 849.5,224.5 854.5,224.5C 854.5,229.5 854.5,234.5 854.5,239.5C 849.5,239.5 844.5,239.5 839.5,239.5C 839.5,234.5 839.5,229.5 839.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 854.5,224.5 C 859.5,224.5 864.5,224.5 869.5,224.5C 869.5,229.5 869.5,234.5 869.5,239.5C 864.5,239.5 859.5,239.5 854.5,239.5C 854.5,234.5 854.5,229.5 854.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 869.5,224.5 C 874.5,224.5 879.5,224.5 884.5,224.5C 884.5,229.5 884.5,234.5 884.5,239.5C 879.5,239.5 874.5,239.5 869.5,239.5C 869.5,234.5 869.5,229.5 869.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,239.5 C 4.5,239.5 9.5,239.5 14.5,239.5C 14.5,244.5 14.5,249.5 14.5,254.5C 9.5,254.5 4.5,254.5 -0.5,254.5C -0.5,249.5 -0.5,244.5 -0.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,239.5 C 19.5,239.5 24.5,239.5 29.5,239.5C 29.5,244.5 29.5,249.5 29.5,254.5C 24.5,254.5 19.5,254.5 14.5,254.5C 14.5,249.5 14.5,244.5 14.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,239.5 C 34.5,239.5 39.5,239.5 44.5,239.5C 44.5,244.5 44.5,249.5 44.5,254.5C 39.5,254.5 34.5,254.5 29.5,254.5C 29.5,249.5 29.5,244.5 29.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,239.5 C 49.5,239.5 54.5,239.5 59.5,239.5C 59.5,244.5 59.5,249.5 59.5,254.5C 54.5,254.5 49.5,254.5 44.5,254.5C 44.5,249.5 44.5,244.5 44.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 59.5,239.5 C 64.5,239.5 69.5,239.5 74.5,239.5C 74.5,244.5 74.5,249.5 74.5,254.5C 69.5,254.5 64.5,254.5 59.5,254.5C 59.5,249.5 59.5,244.5 59.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,239.5 C 829.5,239.5 834.5,239.5 839.5,239.5C 839.5,244.5 839.5,249.5 839.5,254.5C 834.5,254.5 829.5,254.5 824.5,254.5C 824.5,249.5 824.5,244.5 824.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,239.5 C 844.5,239.5 849.5,239.5 854.5,239.5C 854.5,244.5 854.5,249.5 854.5,254.5C 849.5,254.5 844.5,254.5 839.5,254.5C 839.5,249.5 839.5,244.5 839.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,239.5 C 859.5,239.5 864.5,239.5 869.5,239.5C 869.5,244.5 869.5,249.5 869.5,254.5C 864.5,254.5 859.5,254.5 854.5,254.5C 854.5,249.5 854.5,244.5 854.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,239.5 C 874.5,239.5 879.5,239.5 884.5,239.5C 884.5,244.5 884.5,249.5 884.5,254.5C 879.5,254.5 874.5,254.5 869.5,254.5C 869.5,249.5 869.5,244.5 869.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1022f",
    d: "M 231.5,248.5 C 257.278,254.861 282.945,261.695 308.5,269C 313.661,281.649 318.328,294.482 322.5,307.5C 307.375,303.802 292.375,299.635 277.5,295C 261.965,279.632 246.632,264.132 231.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,254.5 C 4.5,254.5 9.5,254.5 14.5,254.5C 14.5,259.5 14.5,264.5 14.5,269.5C 9.5,269.5 4.5,269.5 -0.5,269.5C -0.5,264.5 -0.5,259.5 -0.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,254.5 C 19.5,254.5 24.5,254.5 29.5,254.5C 29.5,259.5 29.5,264.5 29.5,269.5C 24.5,269.5 19.5,269.5 14.5,269.5C 14.5,264.5 14.5,259.5 14.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,254.5 C 34.5,254.5 39.5,254.5 44.5,254.5C 44.5,259.5 44.5,264.5 44.5,269.5C 39.5,269.5 34.5,269.5 29.5,269.5C 29.5,264.5 29.5,259.5 29.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,254.5 C 49.5,254.5 54.5,254.5 59.5,254.5C 59.5,259.5 59.5,264.5 59.5,269.5C 54.5,269.5 49.5,269.5 44.5,269.5C 44.5,264.5 44.5,259.5 44.5,254.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1032f",
    d: "M 329.5,253.5 C 345.132,268.632 360.632,283.965 376,299.5C 377.799,303.07 379.299,306.737 380.5,310.5C 370.167,310.5 359.833,310.5 349.5,310.5C 342.837,291.512 336.17,272.512 329.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,269.5 C 4.5,269.5 9.5,269.5 14.5,269.5C 14.5,274.5 14.5,279.5 14.5,284.5C 9.5,284.5 4.5,284.5 -0.5,284.5C -0.5,279.5 -0.5,274.5 -0.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,269.5 C 19.5,269.5 24.5,269.5 29.5,269.5C 29.5,274.5 29.5,279.5 29.5,284.5C 24.5,284.5 19.5,284.5 14.5,284.5C 14.5,279.5 14.5,274.5 14.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,269.5 C 34.5,269.5 39.5,269.5 44.5,269.5C 44.5,274.5 44.5,279.5 44.5,284.5C 39.5,284.5 34.5,284.5 29.5,284.5C 29.5,279.5 29.5,274.5 29.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,269.5 C 49.5,269.5 54.5,269.5 59.5,269.5C 59.5,274.5 59.5,279.5 59.5,284.5C 54.5,284.5 49.5,284.5 44.5,284.5C 44.5,279.5 44.5,274.5 44.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,284.5 C 4.5,284.5 9.5,284.5 14.5,284.5C 14.5,289.5 14.5,294.5 14.5,299.5C 9.5,299.5 4.5,299.5 -0.5,299.5C -0.5,294.5 -0.5,289.5 -0.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,284.5 C 19.5,284.5 24.5,284.5 29.5,284.5C 29.5,289.5 29.5,294.5 29.5,299.5C 24.5,299.5 19.5,299.5 14.5,299.5C 14.5,294.5 14.5,289.5 14.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,284.5 C 34.5,284.5 39.5,284.5 44.5,284.5C 44.5,289.5 44.5,294.5 44.5,299.5C 39.5,299.5 34.5,299.5 29.5,299.5C 29.5,294.5 29.5,289.5 29.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 44.5,284.5 C 49.5,284.5 54.5,284.5 59.5,284.5C 59.5,289.5 59.5,294.5 59.5,299.5C 54.5,299.5 49.5,299.5 44.5,299.5C 44.5,294.5 44.5,289.5 44.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,299.5 C 4.5,299.5 9.5,299.5 14.5,299.5C 14.5,304.5 14.5,309.5 14.5,314.5C 9.5,314.5 4.5,314.5 -0.5,314.5C -0.5,309.5 -0.5,304.5 -0.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,299.5 C 19.5,299.5 24.5,299.5 29.5,299.5C 29.5,304.5 29.5,309.5 29.5,314.5C 24.5,314.5 19.5,314.5 14.5,314.5C 14.5,309.5 14.5,304.5 14.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,299.5 C 34.5,299.5 39.5,299.5 44.5,299.5C 44.5,304.5 44.5,309.5 44.5,314.5C 39.5,314.5 34.5,314.5 29.5,314.5C 29.5,309.5 29.5,304.5 29.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 44.5,299.5 C 49.5,299.5 54.5,299.5 59.5,299.5C 59.5,304.5 59.5,309.5 59.5,314.5C 54.5,314.5 49.5,314.5 44.5,314.5C 44.5,309.5 44.5,304.5 44.5,299.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,314.5 C 4.5,314.5 9.5,314.5 14.5,314.5C 14.5,319.5 14.5,324.5 14.5,329.5C 9.5,329.5 4.5,329.5 -0.5,329.5C -0.5,324.5 -0.5,319.5 -0.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,314.5 C 19.5,314.5 24.5,314.5 29.5,314.5C 29.5,319.5 29.5,324.5 29.5,329.5C 24.5,329.5 19.5,329.5 14.5,329.5C 14.5,324.5 14.5,319.5 14.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,314.5 C 34.5,314.5 39.5,314.5 44.5,314.5C 44.5,319.5 44.5,324.5 44.5,329.5C 39.5,329.5 34.5,329.5 29.5,329.5C 29.5,324.5 29.5,319.5 29.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebeaea",
    d: "M 869.5,344.5 C 864.5,344.5 859.5,344.5 854.5,344.5C 854.5,349.5 854.5,354.5 854.5,359.5C 851.5,359.5 848.5,359.5 845.5,359.5C 845.768,357.901 845.434,356.568 844.5,355.5C 842.011,337.055 838.344,318.721 833.5,300.5C 835.379,299.659 837.379,299.325 839.5,299.5C 839.5,304.5 839.5,309.5 839.5,314.5C 844.5,314.5 849.5,314.5 854.5,314.5C 854.5,319.5 854.5,324.5 854.5,329.5C 859.5,329.5 864.5,329.5 869.5,329.5C 869.5,334.5 869.5,339.5 869.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1012f",
    d: "M 670.5,315.5 C 686.397,331.38 702.23,347.38 718,363.5C 718.869,365.581 719.369,367.747 719.5,370C 703.017,424.766 685.683,479.266 667.5,533.5C 665.258,535.539 662.758,537.205 660,538.5C 649.667,538.167 639.333,537.833 629,537.5C 628.5,538 628,538.5 627.5,539C 639.731,550.562 651.231,562.729 662,575.5C 670.284,591.705 668.95,607.371 658,622.5C 642.886,637.589 625.719,640.422 606.5,631C 588.692,615.359 571.692,598.859 555.5,581.5C 575.404,592.55 593.571,590.217 610,574.5C 624.689,552.375 622.189,532.542 602.5,515C 581.662,502.772 563.162,505.605 547,523.5C 543.927,528.313 541.427,533.313 539.5,538.5C 513.665,537.845 488.165,537.511 463,537.5C 462.333,538.167 462.333,538.833 463,539.5C 473.658,550.124 484.325,560.791 495,571.5C 505.903,588.07 505.903,604.404 495,620.5C 479.396,637.939 461.229,641.105 440.5,630C 423.994,614.66 407.994,598.827 392.5,582.5C 413.166,592.6 431.333,589.266 447,572.5C 457,556.167 457,539.833 447,523.5C 437.154,511.995 424.654,506.661 409.5,507.5C 403.833,501.5 398.167,495.5 392.5,489.5C 465.472,490.657 538.472,490.824 611.5,490C 616.573,488.594 620.073,485.428 622,480.5C 638.179,428.786 654.512,377.12 671,325.5C 671.543,322.132 671.376,318.799 670.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,329.5 C 4.5,329.5 9.5,329.5 14.5,329.5C 14.5,334.5 14.5,339.5 14.5,344.5C 9.5,344.5 4.5,344.5 -0.5,344.5C -0.5,339.5 -0.5,334.5 -0.5,329.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,329.5 C 19.5,329.5 24.5,329.5 29.5,329.5C 29.5,334.5 29.5,339.5 29.5,344.5C 24.5,344.5 19.5,344.5 14.5,344.5C 14.5,339.5 14.5,334.5 14.5,329.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,329.5 C 34.5,329.5 39.5,329.5 44.5,329.5C 44.5,334.5 44.5,339.5 44.5,344.5C 39.5,344.5 34.5,344.5 29.5,344.5C 29.5,339.5 29.5,334.5 29.5,329.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#df778c",
    d: "M 388.5,334.5 C 378.833,335.167 369.167,335.833 359.5,336.5C 358.957,336.44 358.624,336.107 358.5,335.5C 368.478,334.501 378.478,334.168 388.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b30c32",
    d: "M 388.5,334.5 C 473.167,334.333 557.834,334.5 642.5,335C 639.941,342.843 637.274,350.676 634.5,358.5C 545.5,359.833 456.5,359.833 367.5,358.5C 364.629,351.22 361.963,343.886 359.5,336.5C 369.167,335.833 378.833,335.167 388.5,334.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,344.5 C 4.5,344.5 9.5,344.5 14.5,344.5C 14.5,349.5 14.5,354.5 14.5,359.5C 9.5,359.5 4.5,359.5 -0.5,359.5C -0.5,354.5 -0.5,349.5 -0.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,344.5 C 19.5,344.5 24.5,344.5 29.5,344.5C 29.5,349.5 29.5,354.5 29.5,359.5C 24.5,359.5 19.5,359.5 14.5,359.5C 14.5,354.5 14.5,349.5 14.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,344.5 C 34.5,344.5 39.5,344.5 44.5,344.5C 44.5,349.5 44.5,354.5 44.5,359.5C 39.5,359.5 34.5,359.5 29.5,359.5C 29.5,354.5 29.5,349.5 29.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 869.5,344.5 C 869.5,349.5 869.5,354.5 869.5,359.5C 864.5,359.5 859.5,359.5 854.5,359.5C 854.5,354.5 854.5,349.5 854.5,344.5C 859.5,344.5 864.5,344.5 869.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,359.5 C 4.5,359.5 9.5,359.5 14.5,359.5C 14.5,364.5 14.5,369.5 14.5,374.5C 9.5,374.5 4.5,374.5 -0.5,374.5C -0.5,369.5 -0.5,364.5 -0.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,359.5 C 19.5,359.5 24.5,359.5 29.5,359.5C 29.5,364.5 29.5,369.5 29.5,374.5C 24.5,374.5 19.5,374.5 14.5,374.5C 14.5,369.5 14.5,364.5 14.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,359.5 C 34.5,359.5 39.5,359.5 44.5,359.5C 44.5,364.5 44.5,369.5 44.5,374.5C 39.5,374.5 34.5,374.5 29.5,374.5C 29.5,369.5 29.5,364.5 29.5,359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,374.5 C 4.5,374.5 9.5,374.5 14.5,374.5C 14.5,379.5 14.5,384.5 14.5,389.5C 9.5,389.5 4.5,389.5 -0.5,389.5C -0.5,384.5 -0.5,379.5 -0.5,374.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,374.5 C 19.5,374.5 24.5,374.5 29.5,374.5C 29.5,379.5 29.5,384.5 29.5,389.5C 24.5,389.5 19.5,389.5 14.5,389.5C 14.5,384.5 14.5,379.5 14.5,374.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,374.5 C 34.5,374.5 39.5,374.5 44.5,374.5C 44.5,379.5 44.5,384.5 44.5,389.5C 39.5,389.5 34.5,389.5 29.5,389.5C 29.5,384.5 29.5,379.5 29.5,374.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f2f3",
    d: "M 131.5,179.5 C 87.0679,244.975 64.4013,317.475 63.5,397C 66.6209,536.418 125.288,645.252 239.5,723.5C 239.5,727.167 239.5,730.833 239.5,734.5C 244.5,734.5 249.5,734.5 254.5,734.5C 254.5,739.5 254.5,744.5 254.5,749.5C 259.5,749.5 264.5,749.5 269.5,749.5C 269.5,754.5 269.5,759.5 269.5,764.5C 274.5,764.5 279.5,764.5 284.5,764.5C 284.5,769.5 284.5,774.5 284.5,779.5C 289.5,779.5 294.5,779.5 299.5,779.5C 304.5,779.5 309.5,779.5 314.5,779.5C 319.5,779.5 324.5,779.5 329.5,779.5C 329.5,784.5 329.5,789.5 329.5,794.5C 329.5,799.5 329.5,804.5 329.5,809.5C 324.5,809.5 319.5,809.5 314.5,809.5C 314.5,804.5 314.5,799.5 314.5,794.5C 309.5,794.5 304.5,794.5 299.5,794.5C 299.5,799.5 299.5,804.5 299.5,809.5C 294.5,809.5 289.5,809.5 284.5,809.5C 284.5,804.5 284.5,799.5 284.5,794.5C 279.5,794.5 274.5,794.5 269.5,794.5C 269.5,799.5 269.5,804.5 269.5,809.5C 264.5,809.5 259.5,809.5 254.5,809.5C 254.5,804.5 254.5,799.5 254.5,794.5C 249.5,794.5 244.5,794.5 239.5,794.5C 239.5,799.5 239.5,804.5 239.5,809.5C 234.5,809.5 229.5,809.5 224.5,809.5C 224.5,804.5 224.5,799.5 224.5,794.5C 219.5,794.5 214.5,794.5 209.5,794.5C 209.5,799.5 209.5,804.5 209.5,809.5C 204.5,809.5 199.5,809.5 194.5,809.5C 194.5,804.5 194.5,799.5 194.5,794.5C 189.5,794.5 184.5,794.5 179.5,794.5C 179.5,799.5 179.5,804.5 179.5,809.5C 174.5,809.5 169.5,809.5 164.5,809.5C 164.5,804.5 164.5,799.5 164.5,794.5C 159.5,794.5 154.5,794.5 149.5,794.5C 149.5,799.5 149.5,804.5 149.5,809.5C 144.5,809.5 139.5,809.5 134.5,809.5C 134.5,804.5 134.5,799.5 134.5,794.5C 129.5,794.5 124.5,794.5 119.5,794.5C 119.5,799.5 119.5,804.5 119.5,809.5C 114.5,809.5 109.5,809.5 104.5,809.5C 104.5,804.5 104.5,799.5 104.5,794.5C 99.5,794.5 94.5,794.5 89.5,794.5C 89.5,799.5 89.5,804.5 89.5,809.5C 84.5,809.5 79.5,809.5 74.5,809.5C 74.5,804.5 74.5,799.5 74.5,794.5C 69.5,794.5 64.5,794.5 59.5,794.5C 59.5,799.5 59.5,804.5 59.5,809.5C 54.5,809.5 49.5,809.5 44.5,809.5C 44.5,804.5 44.5,799.5 44.5,794.5C 44.5,789.5 44.5,784.5 44.5,779.5C 44.5,774.5 44.5,769.5 44.5,764.5C 44.5,759.5 44.5,754.5 44.5,749.5C 44.5,744.5 44.5,739.5 44.5,734.5C 44.5,729.5 44.5,724.5 44.5,719.5C 44.5,714.5 44.5,709.5 44.5,704.5C 44.5,699.5 44.5,694.5 44.5,689.5C 44.5,684.5 44.5,679.5 44.5,674.5C 44.5,669.5 44.5,664.5 44.5,659.5C 44.5,654.5 44.5,649.5 44.5,644.5C 44.5,639.5 44.5,634.5 44.5,629.5C 44.5,624.5 44.5,619.5 44.5,614.5C 44.5,609.5 44.5,604.5 44.5,599.5C 44.5,594.5 44.5,589.5 44.5,584.5C 44.5,579.5 44.5,574.5 44.5,569.5C 44.5,564.5 44.5,559.5 44.5,554.5C 44.5,549.5 44.5,544.5 44.5,539.5C 44.5,534.5 44.5,529.5 44.5,524.5C 44.5,519.5 44.5,514.5 44.5,509.5C 44.5,504.5 44.5,499.5 44.5,494.5C 44.5,489.5 44.5,484.5 44.5,479.5C 44.5,474.5 44.5,469.5 44.5,464.5C 44.5,459.5 44.5,454.5 44.5,449.5C 44.5,444.5 44.5,439.5 44.5,434.5C 44.5,429.5 44.5,424.5 44.5,419.5C 44.5,414.5 44.5,409.5 44.5,404.5C 44.5,399.5 44.5,394.5 44.5,389.5C 44.5,384.5 44.5,379.5 44.5,374.5C 44.5,369.5 44.5,364.5 44.5,359.5C 44.5,354.5 44.5,349.5 44.5,344.5C 44.5,339.5 44.5,334.5 44.5,329.5C 44.5,324.5 44.5,319.5 44.5,314.5C 49.5,314.5 54.5,314.5 59.5,314.5C 59.5,309.5 59.5,304.5 59.5,299.5C 59.5,294.5 59.5,289.5 59.5,284.5C 59.5,279.5 59.5,274.5 59.5,269.5C 59.5,264.5 59.5,259.5 59.5,254.5C 64.5,254.5 69.5,254.5 74.5,254.5C 74.5,249.5 74.5,244.5 74.5,239.5C 74.5,234.5 74.5,229.5 74.5,224.5C 79.5,224.5 84.5,224.5 89.5,224.5C 89.5,219.5 89.5,214.5 89.5,209.5C 94.5,209.5 99.5,209.5 104.5,209.5C 104.5,204.5 104.5,199.5 104.5,194.5C 109.5,194.5 114.5,194.5 119.5,194.5C 119.5,189.5 119.5,184.5 119.5,179.5C 123.81,179.383 127.81,179.383 131.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f4f4",
    d: "M 811.5,237.5 C 815.514,239.334 819.847,240.001 824.5,239.5C 824.5,244.5 824.5,249.5 824.5,254.5C 829.5,254.5 834.5,254.5 839.5,254.5C 844.5,254.5 849.5,254.5 854.5,254.5C 859.5,254.5 864.5,254.5 869.5,254.5C 874.5,254.5 879.5,254.5 884.5,254.5C 889.5,254.5 894.5,254.5 899.5,254.5C 899.5,259.5 899.5,264.5 899.5,269.5C 904.5,269.5 909.5,269.5 914.5,269.5C 914.5,274.5 914.5,279.5 914.5,284.5C 909.5,284.5 904.5,284.5 899.5,284.5C 899.5,289.5 899.5,294.5 899.5,299.5C 904.5,299.5 909.5,299.5 914.5,299.5C 914.5,304.5 914.5,309.5 914.5,314.5C 909.5,314.5 904.5,314.5 899.5,314.5C 899.5,319.5 899.5,324.5 899.5,329.5C 904.5,329.5 909.5,329.5 914.5,329.5C 914.5,334.5 914.5,339.5 914.5,344.5C 909.5,344.5 904.5,344.5 899.5,344.5C 899.5,349.5 899.5,354.5 899.5,359.5C 904.5,359.5 909.5,359.5 914.5,359.5C 914.5,364.5 914.5,369.5 914.5,374.5C 909.5,374.5 904.5,374.5 899.5,374.5C 899.5,389.5 899.5,404.5 899.5,419.5C 904.5,419.5 909.5,419.5 914.5,419.5C 914.5,424.5 914.5,429.5 914.5,434.5C 909.5,434.5 904.5,434.5 899.5,434.5C 899.5,439.5 899.5,444.5 899.5,449.5C 904.5,449.5 909.5,449.5 914.5,449.5C 914.5,454.5 914.5,459.5 914.5,464.5C 909.5,464.5 904.5,464.5 899.5,464.5C 899.5,469.5 899.5,474.5 899.5,479.5C 904.5,479.5 909.5,479.5 914.5,479.5C 914.5,484.5 914.5,489.5 914.5,494.5C 909.5,494.5 904.5,494.5 899.5,494.5C 899.5,499.5 899.5,504.5 899.5,509.5C 904.5,509.5 909.5,509.5 914.5,509.5C 914.5,514.5 914.5,519.5 914.5,524.5C 909.5,524.5 904.5,524.5 899.5,524.5C 899.5,529.5 899.5,534.5 899.5,539.5C 904.5,539.5 909.5,539.5 914.5,539.5C 914.5,544.5 914.5,549.5 914.5,554.5C 909.5,554.5 904.5,554.5 899.5,554.5C 899.5,559.5 899.5,564.5 899.5,569.5C 904.5,569.5 909.5,569.5 914.5,569.5C 914.5,574.5 914.5,579.5 914.5,584.5C 909.5,584.5 904.5,584.5 899.5,584.5C 899.5,589.5 899.5,594.5 899.5,599.5C 904.5,599.5 909.5,599.5 914.5,599.5C 914.5,604.5 914.5,609.5 914.5,614.5C 909.5,614.5 904.5,614.5 899.5,614.5C 899.5,619.5 899.5,624.5 899.5,629.5C 904.5,629.5 909.5,629.5 914.5,629.5C 914.5,634.5 914.5,639.5 914.5,644.5C 909.5,644.5 904.5,644.5 899.5,644.5C 899.5,649.5 899.5,654.5 899.5,659.5C 904.5,659.5 909.5,659.5 914.5,659.5C 914.5,664.5 914.5,669.5 914.5,674.5C 909.5,674.5 904.5,674.5 899.5,674.5C 899.5,679.5 899.5,684.5 899.5,689.5C 904.5,689.5 909.5,689.5 914.5,689.5C 914.5,694.5 914.5,699.5 914.5,704.5C 909.5,704.5 904.5,704.5 899.5,704.5C 899.5,709.5 899.5,714.5 899.5,719.5C 904.5,719.5 909.5,719.5 914.5,719.5C 914.5,724.5 914.5,729.5 914.5,734.5C 909.5,734.5 904.5,734.5 899.5,734.5C 899.5,739.5 899.5,744.5 899.5,749.5C 904.5,749.5 909.5,749.5 914.5,749.5C 914.5,754.5 914.5,759.5 914.5,764.5C 909.5,764.5 904.5,764.5 899.5,764.5C 899.5,769.5 899.5,774.5 899.5,779.5C 904.5,779.5 909.5,779.5 914.5,779.5C 914.5,784.5 914.5,789.5 914.5,794.5C 909.5,794.5 904.5,794.5 899.5,794.5C 899.5,799.5 899.5,804.5 899.5,809.5C 894.5,809.5 889.5,809.5 884.5,809.5C 884.5,804.5 884.5,799.5 884.5,794.5C 879.5,794.5 874.5,794.5 869.5,794.5C 869.5,799.5 869.5,804.5 869.5,809.5C 864.5,809.5 859.5,809.5 854.5,809.5C 854.5,804.5 854.5,799.5 854.5,794.5C 849.5,794.5 844.5,794.5 839.5,794.5C 839.5,799.5 839.5,804.5 839.5,809.5C 834.5,809.5 829.5,809.5 824.5,809.5C 824.5,804.5 824.5,799.5 824.5,794.5C 819.5,794.5 814.5,794.5 809.5,794.5C 809.5,799.5 809.5,804.5 809.5,809.5C 804.5,809.5 799.5,809.5 794.5,809.5C 794.5,804.5 794.5,799.5 794.5,794.5C 789.5,794.5 784.5,794.5 779.5,794.5C 779.5,799.5 779.5,804.5 779.5,809.5C 774.5,809.5 769.5,809.5 764.5,809.5C 764.5,804.5 764.5,799.5 764.5,794.5C 759.5,794.5 754.5,794.5 749.5,794.5C 749.5,799.5 749.5,804.5 749.5,809.5C 744.5,809.5 739.5,809.5 734.5,809.5C 734.5,804.5 734.5,799.5 734.5,794.5C 729.5,794.5 724.5,794.5 719.5,794.5C 719.5,799.5 719.5,804.5 719.5,809.5C 714.5,809.5 709.5,809.5 704.5,809.5C 704.5,804.5 704.5,799.5 704.5,794.5C 699.5,794.5 694.5,794.5 689.5,794.5C 689.5,799.5 689.5,804.5 689.5,809.5C 684.5,809.5 679.5,809.5 674.5,809.5C 674.5,804.5 674.5,799.5 674.5,794.5C 669.5,794.5 664.5,794.5 659.5,794.5C 659.5,799.5 659.5,804.5 659.5,809.5C 654.5,809.5 649.5,809.5 644.5,809.5C 644.5,804.5 644.5,799.5 644.5,794.5C 639.5,794.5 634.5,794.5 629.5,794.5C 629.5,799.5 629.5,804.5 629.5,809.5C 624.5,809.5 619.5,809.5 614.5,809.5C 614.5,804.5 614.5,799.5 614.5,794.5C 609.5,794.5 604.5,794.5 599.5,794.5C 599.5,799.5 599.5,804.5 599.5,809.5C 594.5,809.5 589.5,809.5 584.5,809.5C 584.5,804.5 584.5,799.5 584.5,794.5C 579.5,794.5 574.5,794.5 569.5,794.5C 569.5,799.5 569.5,804.5 569.5,809.5C 564.5,809.5 559.5,809.5 554.5,809.5C 554.5,804.5 554.5,799.5 554.5,794.5C 549.5,794.5 544.5,794.5 539.5,794.5C 539.5,799.5 539.5,804.5 539.5,809.5C 534.5,809.5 529.5,809.5 524.5,809.5C 524.5,804.5 524.5,799.5 524.5,794.5C 519.5,794.5 514.5,794.5 509.5,794.5C 509.5,799.5 509.5,804.5 509.5,809.5C 504.5,809.5 499.5,809.5 494.5,809.5C 494.5,804.5 494.5,799.5 494.5,794.5C 489.5,794.5 484.5,794.5 479.5,794.5C 479.5,799.5 479.5,804.5 479.5,809.5C 474.5,809.5 469.5,809.5 464.5,809.5C 464.5,804.5 464.5,799.5 464.5,794.5C 459.5,794.5 454.5,794.5 449.5,794.5C 449.5,799.5 449.5,804.5 449.5,809.5C 444.5,809.5 439.5,809.5 434.5,809.5C 434.5,804.5 434.5,799.5 434.5,794.5C 429.5,794.5 424.5,794.5 419.5,794.5C 419.5,799.5 419.5,804.5 419.5,809.5C 414.5,809.5 409.5,809.5 404.5,809.5C 404.5,804.5 404.5,799.5 404.5,794.5C 399.5,794.5 394.5,794.5 389.5,794.5C 389.5,799.5 389.5,804.5 389.5,809.5C 384.5,809.5 379.5,809.5 374.5,809.5C 374.5,804.5 374.5,799.5 374.5,794.5C 369.5,794.5 364.5,794.5 359.5,794.5C 359.5,789.5 359.5,784.5 359.5,779.5C 354.5,779.5 349.5,779.5 344.5,779.5C 344.5,784.5 344.5,789.5 344.5,794.5C 339.5,794.5 334.5,794.5 329.5,794.5C 329.5,789.5 329.5,784.5 329.5,779.5C 324.5,779.5 319.5,779.5 314.5,779.5C 314.5,774.5 314.5,769.5 314.5,764.5C 309.5,764.5 304.5,764.5 299.5,764.5C 299.5,769.5 299.5,774.5 299.5,779.5C 294.5,779.5 289.5,779.5 284.5,779.5C 284.5,774.5 284.5,769.5 284.5,764.5C 279.5,764.5 274.5,764.5 269.5,764.5C 269.5,759.5 269.5,754.5 269.5,749.5C 264.5,749.5 259.5,749.5 254.5,749.5C 254.5,744.5 254.5,739.5 254.5,734.5C 249.5,734.5 244.5,734.5 239.5,734.5C 239.5,730.833 239.5,727.167 239.5,723.5C 274.666,745.746 312.332,762.579 352.5,774C 467.449,804.006 574.782,787.173 674.5,723.5C 674.5,727.167 674.5,730.833 674.5,734.5C 669.5,734.5 664.5,734.5 659.5,734.5C 659.5,739.5 659.5,744.5 659.5,749.5C 654.5,749.5 649.5,749.5 644.5,749.5C 644.5,754.5 644.5,759.5 644.5,764.5C 649.5,764.5 654.5,764.5 659.5,764.5C 664.5,764.5 669.5,764.5 674.5,764.5C 679.5,764.5 684.5,764.5 689.5,764.5C 694.5,764.5 699.5,764.5 704.5,764.5C 709.5,764.5 714.5,764.5 719.5,764.5C 724.5,764.5 729.5,764.5 734.5,764.5C 739.5,764.5 744.5,764.5 749.5,764.5C 754.5,764.5 759.5,764.5 764.5,764.5C 769.5,764.5 774.5,764.5 779.5,764.5C 784.5,764.5 789.5,764.5 794.5,764.5C 799.5,764.5 804.5,764.5 809.5,764.5C 814.5,764.5 819.5,764.5 824.5,764.5C 829.5,764.5 834.5,764.5 839.5,764.5C 844.5,764.5 849.5,764.5 854.5,764.5C 854.5,759.5 854.5,754.5 854.5,749.5C 854.5,744.5 854.5,739.5 854.5,734.5C 854.5,729.5 854.5,724.5 854.5,719.5C 854.5,714.5 854.5,709.5 854.5,704.5C 854.5,699.5 854.5,694.5 854.5,689.5C 854.5,684.5 854.5,679.5 854.5,674.5C 854.5,669.5 854.5,664.5 854.5,659.5C 854.5,654.5 854.5,649.5 854.5,644.5C 854.5,639.5 854.5,634.5 854.5,629.5C 854.5,624.5 854.5,619.5 854.5,614.5C 854.5,609.5 854.5,604.5 854.5,599.5C 854.5,594.5 854.5,589.5 854.5,584.5C 854.5,579.5 854.5,574.5 854.5,569.5C 854.5,564.5 854.5,559.5 854.5,554.5C 854.5,549.5 854.5,544.5 854.5,539.5C 854.5,534.5 854.5,529.5 854.5,524.5C 849.5,524.5 844.5,524.5 839.5,524.5C 839.5,529.5 839.5,534.5 839.5,539.5C 834.5,539.5 829.5,539.5 824.5,539.5C 824.5,544.5 824.5,549.5 824.5,554.5C 820.97,553.989 817.804,554.656 815,556.5C 814.601,556.272 814.435,555.938 814.5,555.5C 841.827,491.531 851.827,424.865 844.5,355.5C 845.434,356.568 845.768,357.901 845.5,359.5C 848.5,359.5 851.5,359.5 854.5,359.5C 859.5,359.5 864.5,359.5 869.5,359.5C 869.5,354.5 869.5,349.5 869.5,344.5C 869.5,339.5 869.5,334.5 869.5,329.5C 864.5,329.5 859.5,329.5 854.5,329.5C 854.5,324.5 854.5,319.5 854.5,314.5C 849.5,314.5 844.5,314.5 839.5,314.5C 839.5,309.5 839.5,304.5 839.5,299.5C 837.379,299.325 835.379,299.659 833.5,300.5C 827.761,278.951 820.428,257.951 811.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1002f",
    d: "M 376.5,383.5 C 459.833,383.5 543.167,383.5 626.5,383.5C 623.8,393.101 620.8,402.601 617.5,412C 540.498,412.833 463.498,412.667 386.5,411.5C 383.153,402.146 379.82,392.812 376.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,389.5 C 4.5,389.5 9.5,389.5 14.5,389.5C 14.5,394.5 14.5,399.5 14.5,404.5C 9.5,404.5 4.5,404.5 -0.5,404.5C -0.5,399.5 -0.5,394.5 -0.5,389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,389.5 C 19.5,389.5 24.5,389.5 29.5,389.5C 29.5,394.5 29.5,399.5 29.5,404.5C 24.5,404.5 19.5,404.5 14.5,404.5C 14.5,399.5 14.5,394.5 14.5,389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,389.5 C 34.5,389.5 39.5,389.5 44.5,389.5C 44.5,394.5 44.5,399.5 44.5,404.5C 39.5,404.5 34.5,404.5 29.5,404.5C 29.5,399.5 29.5,394.5 29.5,389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,404.5 C 4.5,404.5 9.5,404.5 14.5,404.5C 14.5,409.5 14.5,414.5 14.5,419.5C 9.5,419.5 4.5,419.5 -0.5,419.5C -0.5,414.5 -0.5,409.5 -0.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,404.5 C 19.5,404.5 24.5,404.5 29.5,404.5C 29.5,409.5 29.5,414.5 29.5,419.5C 24.5,419.5 19.5,419.5 14.5,419.5C 14.5,414.5 14.5,409.5 14.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,404.5 C 34.5,404.5 39.5,404.5 44.5,404.5C 44.5,409.5 44.5,414.5 44.5,419.5C 39.5,419.5 34.5,419.5 29.5,419.5C 29.5,414.5 29.5,409.5 29.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,419.5 C 4.5,419.5 9.5,419.5 14.5,419.5C 14.5,424.5 14.5,429.5 14.5,434.5C 9.5,434.5 4.5,434.5 -0.5,434.5C -0.5,429.5 -0.5,424.5 -0.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,419.5 C 19.5,419.5 24.5,419.5 29.5,419.5C 29.5,424.5 29.5,429.5 29.5,434.5C 24.5,434.5 19.5,434.5 14.5,434.5C 14.5,429.5 14.5,424.5 14.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,419.5 C 34.5,419.5 39.5,419.5 44.5,419.5C 44.5,424.5 44.5,429.5 44.5,434.5C 39.5,434.5 34.5,434.5 29.5,434.5C 29.5,429.5 29.5,424.5 29.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,434.5 C 4.5,434.5 9.5,434.5 14.5,434.5C 14.5,439.5 14.5,444.5 14.5,449.5C 9.5,449.5 4.5,449.5 -0.5,449.5C -0.5,444.5 -0.5,439.5 -0.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,434.5 C 19.5,434.5 24.5,434.5 29.5,434.5C 29.5,439.5 29.5,444.5 29.5,449.5C 24.5,449.5 19.5,449.5 14.5,449.5C 14.5,444.5 14.5,439.5 14.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,434.5 C 34.5,434.5 39.5,434.5 44.5,434.5C 44.5,439.5 44.5,444.5 44.5,449.5C 39.5,449.5 34.5,449.5 29.5,449.5C 29.5,444.5 29.5,439.5 29.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1002f",
    d: "M 396.5,437.5 C 467.5,437.5 538.5,437.5 609.5,437.5C 606.631,446.775 603.964,456.108 601.5,465.5C 536.167,465.5 470.833,465.5 405.5,465.5C 402.5,456.167 399.5,446.833 396.5,437.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,449.5 C 4.5,449.5 9.5,449.5 14.5,449.5C 14.5,454.5 14.5,459.5 14.5,464.5C 9.5,464.5 4.5,464.5 -0.5,464.5C -0.5,459.5 -0.5,454.5 -0.5,449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,449.5 C 19.5,449.5 24.5,449.5 29.5,449.5C 29.5,454.5 29.5,459.5 29.5,464.5C 24.5,464.5 19.5,464.5 14.5,464.5C 14.5,459.5 14.5,454.5 14.5,449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,449.5 C 34.5,449.5 39.5,449.5 44.5,449.5C 44.5,454.5 44.5,459.5 44.5,464.5C 39.5,464.5 34.5,464.5 29.5,464.5C 29.5,459.5 29.5,454.5 29.5,449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,464.5 C 4.5,464.5 9.5,464.5 14.5,464.5C 14.5,469.5 14.5,474.5 14.5,479.5C 9.5,479.5 4.5,479.5 -0.5,479.5C -0.5,474.5 -0.5,469.5 -0.5,464.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,464.5 C 19.5,464.5 24.5,464.5 29.5,464.5C 29.5,469.5 29.5,474.5 29.5,479.5C 24.5,479.5 19.5,479.5 14.5,479.5C 14.5,474.5 14.5,469.5 14.5,464.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,464.5 C 34.5,464.5 39.5,464.5 44.5,464.5C 44.5,469.5 44.5,474.5 44.5,479.5C 39.5,479.5 34.5,479.5 29.5,479.5C 29.5,474.5 29.5,469.5 29.5,464.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,479.5 C 4.5,479.5 9.5,479.5 14.5,479.5C 14.5,484.5 14.5,489.5 14.5,494.5C 9.5,494.5 4.5,494.5 -0.5,494.5C -0.5,489.5 -0.5,484.5 -0.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,479.5 C 19.5,479.5 24.5,479.5 29.5,479.5C 29.5,484.5 29.5,489.5 29.5,494.5C 24.5,494.5 19.5,494.5 14.5,494.5C 14.5,489.5 14.5,484.5 14.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,479.5 C 34.5,479.5 39.5,479.5 44.5,479.5C 44.5,484.5 44.5,489.5 44.5,494.5C 39.5,494.5 34.5,494.5 29.5,494.5C 29.5,489.5 29.5,484.5 29.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,494.5 C 4.5,494.5 9.5,494.5 14.5,494.5C 14.5,499.5 14.5,504.5 14.5,509.5C 9.5,509.5 4.5,509.5 -0.5,509.5C -0.5,504.5 -0.5,499.5 -0.5,494.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,494.5 C 19.5,494.5 24.5,494.5 29.5,494.5C 29.5,499.5 29.5,504.5 29.5,509.5C 24.5,509.5 19.5,509.5 14.5,509.5C 14.5,504.5 14.5,499.5 14.5,494.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,494.5 C 34.5,494.5 39.5,494.5 44.5,494.5C 44.5,499.5 44.5,504.5 44.5,509.5C 39.5,509.5 34.5,509.5 29.5,509.5C 29.5,504.5 29.5,499.5 29.5,494.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,494.5 C 844.5,494.5 849.5,494.5 854.5,494.5C 854.5,499.5 854.5,504.5 854.5,509.5C 849.5,509.5 844.5,509.5 839.5,509.5C 839.5,504.5 839.5,499.5 839.5,494.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 409.5,507.5 C 424.654,506.661 437.154,511.995 447,523.5C 457,539.833 457,556.167 447,572.5C 431.333,589.266 413.166,592.6 392.5,582.5C 374.212,567.463 370.045,549.129 380,527.5C 387.093,516.71 396.927,510.043 409.5,507.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 555.5,581.5 C 542.261,570.116 536.927,555.782 539.5,538.5C 541.427,533.313 543.927,528.313 547,523.5C 563.162,505.605 581.662,502.772 602.5,515C 622.189,532.542 624.689,552.375 610,574.5C 593.571,590.217 575.404,592.55 555.5,581.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,509.5 C 4.5,509.5 9.5,509.5 14.5,509.5C 14.5,514.5 14.5,519.5 14.5,524.5C 9.5,524.5 4.5,524.5 -0.5,524.5C -0.5,519.5 -0.5,514.5 -0.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,509.5 C 19.5,509.5 24.5,509.5 29.5,509.5C 29.5,514.5 29.5,519.5 29.5,524.5C 24.5,524.5 19.5,524.5 14.5,524.5C 14.5,519.5 14.5,514.5 14.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,509.5 C 34.5,509.5 39.5,509.5 44.5,509.5C 44.5,514.5 44.5,519.5 44.5,524.5C 39.5,524.5 34.5,524.5 29.5,524.5C 29.5,519.5 29.5,514.5 29.5,509.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,524.5 C 4.5,524.5 9.5,524.5 14.5,524.5C 14.5,529.5 14.5,534.5 14.5,539.5C 9.5,539.5 4.5,539.5 -0.5,539.5C -0.5,534.5 -0.5,529.5 -0.5,524.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,524.5 C 19.5,524.5 24.5,524.5 29.5,524.5C 29.5,529.5 29.5,534.5 29.5,539.5C 24.5,539.5 19.5,539.5 14.5,539.5C 14.5,534.5 14.5,529.5 14.5,524.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,524.5 C 34.5,524.5 39.5,524.5 44.5,524.5C 44.5,529.5 44.5,534.5 44.5,539.5C 39.5,539.5 34.5,539.5 29.5,539.5C 29.5,534.5 29.5,529.5 29.5,524.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 854.5,539.5 C 849.5,539.5 844.5,539.5 839.5,539.5C 839.5,534.5 839.5,529.5 839.5,524.5C 844.5,524.5 849.5,524.5 854.5,524.5C 854.5,529.5 854.5,534.5 854.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b20731",
    d: "M 409.5,532.5 C 424.459,530.96 431.292,537.626 430,552.5C 424.888,563.743 416.721,566.576 405.5,561C 395.484,549.913 396.817,540.413 409.5,532.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b20530",
    d: "M 574.5,532.5 C 592.172,532.504 598.005,540.838 592,557.5C 584.835,564.455 577.001,565.288 568.5,560C 560.33,548.459 562.33,539.292 574.5,532.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,539.5 C 4.5,539.5 9.5,539.5 14.5,539.5C 14.5,544.5 14.5,549.5 14.5,554.5C 9.5,554.5 4.5,554.5 -0.5,554.5C -0.5,549.5 -0.5,544.5 -0.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,539.5 C 19.5,539.5 24.5,539.5 29.5,539.5C 29.5,544.5 29.5,549.5 29.5,554.5C 24.5,554.5 19.5,554.5 14.5,554.5C 14.5,549.5 14.5,544.5 14.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,539.5 C 34.5,539.5 39.5,539.5 44.5,539.5C 44.5,544.5 44.5,549.5 44.5,554.5C 39.5,554.5 34.5,554.5 29.5,554.5C 29.5,549.5 29.5,544.5 29.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,539.5 C 839.5,544.5 839.5,549.5 839.5,554.5C 834.5,554.5 829.5,554.5 824.5,554.5C 824.5,549.5 824.5,544.5 824.5,539.5C 829.5,539.5 834.5,539.5 839.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,539.5 C 844.5,539.5 849.5,539.5 854.5,539.5C 854.5,544.5 854.5,549.5 854.5,554.5C 849.5,554.5 844.5,554.5 839.5,554.5C 839.5,549.5 839.5,544.5 839.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,554.5 C 4.5,554.5 9.5,554.5 14.5,554.5C 14.5,559.5 14.5,564.5 14.5,569.5C 9.5,569.5 4.5,569.5 -0.5,569.5C -0.5,564.5 -0.5,559.5 -0.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,554.5 C 19.5,554.5 24.5,554.5 29.5,554.5C 29.5,559.5 29.5,564.5 29.5,569.5C 24.5,569.5 19.5,569.5 14.5,569.5C 14.5,564.5 14.5,559.5 14.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,554.5 C 34.5,554.5 39.5,554.5 44.5,554.5C 44.5,559.5 44.5,564.5 44.5,569.5C 39.5,569.5 34.5,569.5 29.5,569.5C 29.5,564.5 29.5,559.5 29.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7e6e6",
    d: "M 824.5,554.5 C 824.5,559.5 824.5,564.5 824.5,569.5C 819.5,569.5 814.5,569.5 809.5,569.5C 809.5,574.5 809.5,579.5 809.5,584.5C 806.615,584.806 803.948,584.473 801.5,583.5C 805.87,574.098 810.204,564.764 814.5,555.5C 814.435,555.938 814.601,556.272 815,556.5C 817.804,554.656 820.97,553.989 824.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,554.5 C 829.5,554.5 834.5,554.5 839.5,554.5C 839.5,559.5 839.5,564.5 839.5,569.5C 834.5,569.5 829.5,569.5 824.5,569.5C 824.5,564.5 824.5,559.5 824.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,554.5 C 844.5,554.5 849.5,554.5 854.5,554.5C 854.5,559.5 854.5,564.5 854.5,569.5C 849.5,569.5 844.5,569.5 839.5,569.5C 839.5,564.5 839.5,559.5 839.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,569.5 C 4.5,569.5 9.5,569.5 14.5,569.5C 14.5,574.5 14.5,579.5 14.5,584.5C 9.5,584.5 4.5,584.5 -0.5,584.5C -0.5,579.5 -0.5,574.5 -0.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,569.5 C 19.5,569.5 24.5,569.5 29.5,569.5C 29.5,574.5 29.5,579.5 29.5,584.5C 24.5,584.5 19.5,584.5 14.5,584.5C 14.5,579.5 14.5,574.5 14.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,569.5 C 34.5,569.5 39.5,569.5 44.5,569.5C 44.5,574.5 44.5,579.5 44.5,584.5C 39.5,584.5 34.5,584.5 29.5,584.5C 29.5,579.5 29.5,574.5 29.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,569.5 C 824.5,574.5 824.5,579.5 824.5,584.5C 819.5,584.5 814.5,584.5 809.5,584.5C 809.5,579.5 809.5,574.5 809.5,569.5C 814.5,569.5 819.5,569.5 824.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,569.5 C 829.5,569.5 834.5,569.5 839.5,569.5C 839.5,574.5 839.5,579.5 839.5,584.5C 834.5,584.5 829.5,584.5 824.5,584.5C 824.5,579.5 824.5,574.5 824.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,569.5 C 844.5,569.5 849.5,569.5 854.5,569.5C 854.5,574.5 854.5,579.5 854.5,584.5C 849.5,584.5 844.5,584.5 839.5,584.5C 839.5,579.5 839.5,574.5 839.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,584.5 C 4.5,584.5 9.5,584.5 14.5,584.5C 14.5,589.5 14.5,594.5 14.5,599.5C 9.5,599.5 4.5,599.5 -0.5,599.5C -0.5,594.5 -0.5,589.5 -0.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,584.5 C 19.5,584.5 24.5,584.5 29.5,584.5C 29.5,589.5 29.5,594.5 29.5,599.5C 24.5,599.5 19.5,599.5 14.5,599.5C 14.5,594.5 14.5,589.5 14.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,584.5 C 34.5,584.5 39.5,584.5 44.5,584.5C 44.5,589.5 44.5,594.5 44.5,599.5C 39.5,599.5 34.5,599.5 29.5,599.5C 29.5,594.5 29.5,589.5 29.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,584.5 C 814.5,584.5 819.5,584.5 824.5,584.5C 824.5,589.5 824.5,594.5 824.5,599.5C 819.5,599.5 814.5,599.5 809.5,599.5C 809.5,594.5 809.5,589.5 809.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,584.5 C 829.5,584.5 834.5,584.5 839.5,584.5C 839.5,589.5 839.5,594.5 839.5,599.5C 834.5,599.5 829.5,599.5 824.5,599.5C 824.5,594.5 824.5,589.5 824.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,584.5 C 844.5,584.5 849.5,584.5 854.5,584.5C 854.5,589.5 854.5,594.5 854.5,599.5C 849.5,599.5 844.5,599.5 839.5,599.5C 839.5,594.5 839.5,589.5 839.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfcfc",
    d: "M 801.5,583.5 C 803.948,584.473 806.615,584.806 809.5,584.5C 809.5,589.5 809.5,594.5 809.5,599.5C 804.5,599.5 799.5,599.5 794.5,599.5C 794.5,604.5 794.5,609.5 794.5,614.5C 789.86,613.975 785.527,614.642 781.5,616.5C 788.174,605.495 794.841,594.495 801.5,583.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,599.5 C 4.5,599.5 9.5,599.5 14.5,599.5C 14.5,604.5 14.5,609.5 14.5,614.5C 9.5,614.5 4.5,614.5 -0.5,614.5C -0.5,609.5 -0.5,604.5 -0.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,599.5 C 19.5,599.5 24.5,599.5 29.5,599.5C 29.5,604.5 29.5,609.5 29.5,614.5C 24.5,614.5 19.5,614.5 14.5,614.5C 14.5,609.5 14.5,604.5 14.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,599.5 C 34.5,599.5 39.5,599.5 44.5,599.5C 44.5,604.5 44.5,609.5 44.5,614.5C 39.5,614.5 34.5,614.5 29.5,614.5C 29.5,609.5 29.5,604.5 29.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,599.5 C 809.5,604.5 809.5,609.5 809.5,614.5C 804.5,614.5 799.5,614.5 794.5,614.5C 794.5,609.5 794.5,604.5 794.5,599.5C 799.5,599.5 804.5,599.5 809.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,599.5 C 814.5,599.5 819.5,599.5 824.5,599.5C 824.5,604.5 824.5,609.5 824.5,614.5C 819.5,614.5 814.5,614.5 809.5,614.5C 809.5,609.5 809.5,604.5 809.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,599.5 C 829.5,599.5 834.5,599.5 839.5,599.5C 839.5,604.5 839.5,609.5 839.5,614.5C 834.5,614.5 829.5,614.5 824.5,614.5C 824.5,609.5 824.5,604.5 824.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,599.5 C 844.5,599.5 849.5,599.5 854.5,599.5C 854.5,604.5 854.5,609.5 854.5,614.5C 849.5,614.5 844.5,614.5 839.5,614.5C 839.5,609.5 839.5,604.5 839.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,614.5 C 4.5,614.5 9.5,614.5 14.5,614.5C 14.5,619.5 14.5,624.5 14.5,629.5C 9.5,629.5 4.5,629.5 -0.5,629.5C -0.5,624.5 -0.5,619.5 -0.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,614.5 C 19.5,614.5 24.5,614.5 29.5,614.5C 29.5,619.5 29.5,624.5 29.5,629.5C 24.5,629.5 19.5,629.5 14.5,629.5C 14.5,624.5 14.5,619.5 14.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,614.5 C 34.5,614.5 39.5,614.5 44.5,614.5C 44.5,619.5 44.5,624.5 44.5,629.5C 39.5,629.5 34.5,629.5 29.5,629.5C 29.5,624.5 29.5,619.5 29.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,614.5 C 799.5,614.5 804.5,614.5 809.5,614.5C 809.5,619.5 809.5,624.5 809.5,629.5C 804.5,629.5 799.5,629.5 794.5,629.5C 794.5,624.5 794.5,619.5 794.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,614.5 C 814.5,614.5 819.5,614.5 824.5,614.5C 824.5,619.5 824.5,624.5 824.5,629.5C 819.5,629.5 814.5,629.5 809.5,629.5C 809.5,624.5 809.5,619.5 809.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,614.5 C 829.5,614.5 834.5,614.5 839.5,614.5C 839.5,619.5 839.5,624.5 839.5,629.5C 834.5,629.5 829.5,629.5 824.5,629.5C 824.5,624.5 824.5,619.5 824.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,614.5 C 844.5,614.5 849.5,614.5 854.5,614.5C 854.5,619.5 854.5,624.5 854.5,629.5C 849.5,629.5 844.5,629.5 839.5,629.5C 839.5,624.5 839.5,619.5 839.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,629.5 C 4.5,629.5 9.5,629.5 14.5,629.5C 14.5,634.5 14.5,639.5 14.5,644.5C 9.5,644.5 4.5,644.5 -0.5,644.5C -0.5,639.5 -0.5,634.5 -0.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,629.5 C 19.5,629.5 24.5,629.5 29.5,629.5C 29.5,634.5 29.5,639.5 29.5,644.5C 24.5,644.5 19.5,644.5 14.5,644.5C 14.5,639.5 14.5,634.5 14.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,629.5 C 34.5,629.5 39.5,629.5 44.5,629.5C 44.5,634.5 44.5,639.5 44.5,644.5C 39.5,644.5 34.5,644.5 29.5,644.5C 29.5,639.5 29.5,634.5 29.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e8e8",
    d: "M 794.5,614.5 C 794.5,619.5 794.5,624.5 794.5,629.5C 789.5,629.5 784.5,629.5 779.5,629.5C 779.5,634.5 779.5,639.5 779.5,644.5C 774.5,644.5 769.5,644.5 764.5,644.5C 764.5,649.5 764.5,654.5 764.5,659.5C 759.5,659.5 754.5,659.5 749.5,659.5C 749.5,664.5 749.5,669.5 749.5,674.5C 744.821,674.666 740.155,674.499 735.5,674C 736.738,673.31 736.738,672.81 735.5,672.5C 752.278,654.897 767.611,636.231 781.5,616.5C 785.527,614.642 789.86,613.975 794.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,629.5 C 794.5,634.5 794.5,639.5 794.5,644.5C 789.5,644.5 784.5,644.5 779.5,644.5C 779.5,639.5 779.5,634.5 779.5,629.5C 784.5,629.5 789.5,629.5 794.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,629.5 C 799.5,629.5 804.5,629.5 809.5,629.5C 809.5,634.5 809.5,639.5 809.5,644.5C 804.5,644.5 799.5,644.5 794.5,644.5C 794.5,639.5 794.5,634.5 794.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,629.5 C 814.5,629.5 819.5,629.5 824.5,629.5C 824.5,634.5 824.5,639.5 824.5,644.5C 819.5,644.5 814.5,644.5 809.5,644.5C 809.5,639.5 809.5,634.5 809.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,629.5 C 829.5,629.5 834.5,629.5 839.5,629.5C 839.5,634.5 839.5,639.5 839.5,644.5C 834.5,644.5 829.5,644.5 824.5,644.5C 824.5,639.5 824.5,634.5 824.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,629.5 C 844.5,629.5 849.5,629.5 854.5,629.5C 854.5,634.5 854.5,639.5 854.5,644.5C 849.5,644.5 844.5,644.5 839.5,644.5C 839.5,639.5 839.5,634.5 839.5,629.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,644.5 C 4.5,644.5 9.5,644.5 14.5,644.5C 14.5,649.5 14.5,654.5 14.5,659.5C 9.5,659.5 4.5,659.5 -0.5,659.5C -0.5,654.5 -0.5,649.5 -0.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,644.5 C 19.5,644.5 24.5,644.5 29.5,644.5C 29.5,649.5 29.5,654.5 29.5,659.5C 24.5,659.5 19.5,659.5 14.5,659.5C 14.5,654.5 14.5,649.5 14.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,644.5 C 34.5,644.5 39.5,644.5 44.5,644.5C 44.5,649.5 44.5,654.5 44.5,659.5C 39.5,659.5 34.5,659.5 29.5,659.5C 29.5,654.5 29.5,649.5 29.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,644.5 C 779.5,649.5 779.5,654.5 779.5,659.5C 774.5,659.5 769.5,659.5 764.5,659.5C 764.5,654.5 764.5,649.5 764.5,644.5C 769.5,644.5 774.5,644.5 779.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,644.5 C 784.5,644.5 789.5,644.5 794.5,644.5C 794.5,649.5 794.5,654.5 794.5,659.5C 789.5,659.5 784.5,659.5 779.5,659.5C 779.5,654.5 779.5,649.5 779.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,644.5 C 799.5,644.5 804.5,644.5 809.5,644.5C 809.5,649.5 809.5,654.5 809.5,659.5C 804.5,659.5 799.5,659.5 794.5,659.5C 794.5,654.5 794.5,649.5 794.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,644.5 C 814.5,644.5 819.5,644.5 824.5,644.5C 824.5,649.5 824.5,654.5 824.5,659.5C 819.5,659.5 814.5,659.5 809.5,659.5C 809.5,654.5 809.5,649.5 809.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,644.5 C 829.5,644.5 834.5,644.5 839.5,644.5C 839.5,649.5 839.5,654.5 839.5,659.5C 834.5,659.5 829.5,659.5 824.5,659.5C 824.5,654.5 824.5,649.5 824.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,644.5 C 844.5,644.5 849.5,644.5 854.5,644.5C 854.5,649.5 854.5,654.5 854.5,659.5C 849.5,659.5 844.5,659.5 839.5,659.5C 839.5,654.5 839.5,649.5 839.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,659.5 C 4.5,659.5 9.5,659.5 14.5,659.5C 14.5,664.5 14.5,669.5 14.5,674.5C 9.5,674.5 4.5,674.5 -0.5,674.5C -0.5,669.5 -0.5,664.5 -0.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,659.5 C 19.5,659.5 24.5,659.5 29.5,659.5C 29.5,664.5 29.5,669.5 29.5,674.5C 24.5,674.5 19.5,674.5 14.5,674.5C 14.5,669.5 14.5,664.5 14.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,659.5 C 34.5,659.5 39.5,659.5 44.5,659.5C 44.5,664.5 44.5,669.5 44.5,674.5C 39.5,674.5 34.5,674.5 29.5,674.5C 29.5,669.5 29.5,664.5 29.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,659.5 C 764.5,664.5 764.5,669.5 764.5,674.5C 759.5,674.5 754.5,674.5 749.5,674.5C 749.5,669.5 749.5,664.5 749.5,659.5C 754.5,659.5 759.5,659.5 764.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,659.5 C 769.5,659.5 774.5,659.5 779.5,659.5C 779.5,664.5 779.5,669.5 779.5,674.5C 774.5,674.5 769.5,674.5 764.5,674.5C 764.5,669.5 764.5,664.5 764.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,659.5 C 784.5,659.5 789.5,659.5 794.5,659.5C 794.5,664.5 794.5,669.5 794.5,674.5C 789.5,674.5 784.5,674.5 779.5,674.5C 779.5,669.5 779.5,664.5 779.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,659.5 C 799.5,659.5 804.5,659.5 809.5,659.5C 809.5,664.5 809.5,669.5 809.5,674.5C 804.5,674.5 799.5,674.5 794.5,674.5C 794.5,669.5 794.5,664.5 794.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,659.5 C 814.5,659.5 819.5,659.5 824.5,659.5C 824.5,664.5 824.5,669.5 824.5,674.5C 819.5,674.5 814.5,674.5 809.5,674.5C 809.5,669.5 809.5,664.5 809.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,659.5 C 829.5,659.5 834.5,659.5 839.5,659.5C 839.5,664.5 839.5,669.5 839.5,674.5C 834.5,674.5 829.5,674.5 824.5,674.5C 824.5,669.5 824.5,664.5 824.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,659.5 C 844.5,659.5 849.5,659.5 854.5,659.5C 854.5,664.5 854.5,669.5 854.5,674.5C 849.5,674.5 844.5,674.5 839.5,674.5C 839.5,669.5 839.5,664.5 839.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 735.5,672.5 C 736.738,672.81 736.738,673.31 735.5,674C 740.155,674.499 744.821,674.666 749.5,674.5C 749.5,679.5 749.5,684.5 749.5,689.5C 744.5,689.5 739.5,689.5 734.5,689.5C 735.103,684.381 734.436,679.715 732.5,675.5C 733.167,674.167 734.167,673.167 735.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,674.5 C 4.5,674.5 9.5,674.5 14.5,674.5C 14.5,679.5 14.5,684.5 14.5,689.5C 9.5,689.5 4.5,689.5 -0.5,689.5C -0.5,684.5 -0.5,679.5 -0.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,674.5 C 19.5,674.5 24.5,674.5 29.5,674.5C 29.5,679.5 29.5,684.5 29.5,689.5C 24.5,689.5 19.5,689.5 14.5,689.5C 14.5,684.5 14.5,679.5 14.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,674.5 C 34.5,674.5 39.5,674.5 44.5,674.5C 44.5,679.5 44.5,684.5 44.5,689.5C 39.5,689.5 34.5,689.5 29.5,689.5C 29.5,684.5 29.5,679.5 29.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 749.5,674.5 C 754.5,674.5 759.5,674.5 764.5,674.5C 764.5,679.5 764.5,684.5 764.5,689.5C 759.5,689.5 754.5,689.5 749.5,689.5C 749.5,684.5 749.5,679.5 749.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,674.5 C 769.5,674.5 774.5,674.5 779.5,674.5C 779.5,679.5 779.5,684.5 779.5,689.5C 774.5,689.5 769.5,689.5 764.5,689.5C 764.5,684.5 764.5,679.5 764.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,674.5 C 784.5,674.5 789.5,674.5 794.5,674.5C 794.5,679.5 794.5,684.5 794.5,689.5C 789.5,689.5 784.5,689.5 779.5,689.5C 779.5,684.5 779.5,679.5 779.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,674.5 C 799.5,674.5 804.5,674.5 809.5,674.5C 809.5,679.5 809.5,684.5 809.5,689.5C 804.5,689.5 799.5,689.5 794.5,689.5C 794.5,684.5 794.5,679.5 794.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,674.5 C 814.5,674.5 819.5,674.5 824.5,674.5C 824.5,679.5 824.5,684.5 824.5,689.5C 819.5,689.5 814.5,689.5 809.5,689.5C 809.5,684.5 809.5,679.5 809.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,674.5 C 829.5,674.5 834.5,674.5 839.5,674.5C 839.5,679.5 839.5,684.5 839.5,689.5C 834.5,689.5 829.5,689.5 824.5,689.5C 824.5,684.5 824.5,679.5 824.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,674.5 C 844.5,674.5 849.5,674.5 854.5,674.5C 854.5,679.5 854.5,684.5 854.5,689.5C 849.5,689.5 844.5,689.5 839.5,689.5C 839.5,684.5 839.5,679.5 839.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,689.5 C 4.5,689.5 9.5,689.5 14.5,689.5C 14.5,694.5 14.5,699.5 14.5,704.5C 9.5,704.5 4.5,704.5 -0.5,704.5C -0.5,699.5 -0.5,694.5 -0.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,689.5 C 19.5,689.5 24.5,689.5 29.5,689.5C 29.5,694.5 29.5,699.5 29.5,704.5C 24.5,704.5 19.5,704.5 14.5,704.5C 14.5,699.5 14.5,694.5 14.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,689.5 C 34.5,689.5 39.5,689.5 44.5,689.5C 44.5,694.5 44.5,699.5 44.5,704.5C 39.5,704.5 34.5,704.5 29.5,704.5C 29.5,699.5 29.5,694.5 29.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e7e8",
    d: "M 732.5,675.5 C 734.436,679.715 735.103,684.381 734.5,689.5C 729.5,689.5 724.5,689.5 719.5,689.5C 719.5,694.5 719.5,699.5 719.5,704.5C 714.5,704.5 709.5,704.5 704.5,704.5C 704.5,709.5 704.5,714.5 704.5,719.5C 699.5,719.5 694.5,719.5 689.5,719.5C 689.5,724.5 689.5,729.5 689.5,734.5C 684.5,734.5 679.5,734.5 674.5,734.5C 674.5,730.833 674.5,727.167 674.5,723.5C 695.266,709.416 714.599,693.416 732.5,675.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 734.5,689.5 C 734.5,694.5 734.5,699.5 734.5,704.5C 729.5,704.5 724.5,704.5 719.5,704.5C 719.5,699.5 719.5,694.5 719.5,689.5C 724.5,689.5 729.5,689.5 734.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 734.5,689.5 C 739.5,689.5 744.5,689.5 749.5,689.5C 749.5,694.5 749.5,699.5 749.5,704.5C 744.5,704.5 739.5,704.5 734.5,704.5C 734.5,699.5 734.5,694.5 734.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 749.5,689.5 C 754.5,689.5 759.5,689.5 764.5,689.5C 764.5,694.5 764.5,699.5 764.5,704.5C 759.5,704.5 754.5,704.5 749.5,704.5C 749.5,699.5 749.5,694.5 749.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,689.5 C 769.5,689.5 774.5,689.5 779.5,689.5C 779.5,694.5 779.5,699.5 779.5,704.5C 774.5,704.5 769.5,704.5 764.5,704.5C 764.5,699.5 764.5,694.5 764.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,689.5 C 784.5,689.5 789.5,689.5 794.5,689.5C 794.5,694.5 794.5,699.5 794.5,704.5C 789.5,704.5 784.5,704.5 779.5,704.5C 779.5,699.5 779.5,694.5 779.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,689.5 C 799.5,689.5 804.5,689.5 809.5,689.5C 809.5,694.5 809.5,699.5 809.5,704.5C 804.5,704.5 799.5,704.5 794.5,704.5C 794.5,699.5 794.5,694.5 794.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,689.5 C 814.5,689.5 819.5,689.5 824.5,689.5C 824.5,694.5 824.5,699.5 824.5,704.5C 819.5,704.5 814.5,704.5 809.5,704.5C 809.5,699.5 809.5,694.5 809.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,689.5 C 829.5,689.5 834.5,689.5 839.5,689.5C 839.5,694.5 839.5,699.5 839.5,704.5C 834.5,704.5 829.5,704.5 824.5,704.5C 824.5,699.5 824.5,694.5 824.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,689.5 C 844.5,689.5 849.5,689.5 854.5,689.5C 854.5,694.5 854.5,699.5 854.5,704.5C 849.5,704.5 844.5,704.5 839.5,704.5C 839.5,699.5 839.5,694.5 839.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,704.5 C 4.5,704.5 9.5,704.5 14.5,704.5C 14.5,709.5 14.5,714.5 14.5,719.5C 9.5,719.5 4.5,719.5 -0.5,719.5C -0.5,714.5 -0.5,709.5 -0.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,704.5 C 19.5,704.5 24.5,704.5 29.5,704.5C 29.5,709.5 29.5,714.5 29.5,719.5C 24.5,719.5 19.5,719.5 14.5,719.5C 14.5,714.5 14.5,709.5 14.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,704.5 C 34.5,704.5 39.5,704.5 44.5,704.5C 44.5,709.5 44.5,714.5 44.5,719.5C 39.5,719.5 34.5,719.5 29.5,719.5C 29.5,714.5 29.5,709.5 29.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 719.5,704.5 C 719.5,709.5 719.5,714.5 719.5,719.5C 714.5,719.5 709.5,719.5 704.5,719.5C 704.5,714.5 704.5,709.5 704.5,704.5C 709.5,704.5 714.5,704.5 719.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 719.5,704.5 C 724.5,704.5 729.5,704.5 734.5,704.5C 734.5,709.5 734.5,714.5 734.5,719.5C 729.5,719.5 724.5,719.5 719.5,719.5C 719.5,714.5 719.5,709.5 719.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 734.5,704.5 C 739.5,704.5 744.5,704.5 749.5,704.5C 749.5,709.5 749.5,714.5 749.5,719.5C 744.5,719.5 739.5,719.5 734.5,719.5C 734.5,714.5 734.5,709.5 734.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 749.5,704.5 C 754.5,704.5 759.5,704.5 764.5,704.5C 764.5,709.5 764.5,714.5 764.5,719.5C 759.5,719.5 754.5,719.5 749.5,719.5C 749.5,714.5 749.5,709.5 749.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,704.5 C 769.5,704.5 774.5,704.5 779.5,704.5C 779.5,709.5 779.5,714.5 779.5,719.5C 774.5,719.5 769.5,719.5 764.5,719.5C 764.5,714.5 764.5,709.5 764.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,704.5 C 784.5,704.5 789.5,704.5 794.5,704.5C 794.5,709.5 794.5,714.5 794.5,719.5C 789.5,719.5 784.5,719.5 779.5,719.5C 779.5,714.5 779.5,709.5 779.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,704.5 C 799.5,704.5 804.5,704.5 809.5,704.5C 809.5,709.5 809.5,714.5 809.5,719.5C 804.5,719.5 799.5,719.5 794.5,719.5C 794.5,714.5 794.5,709.5 794.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,704.5 C 814.5,704.5 819.5,704.5 824.5,704.5C 824.5,709.5 824.5,714.5 824.5,719.5C 819.5,719.5 814.5,719.5 809.5,719.5C 809.5,714.5 809.5,709.5 809.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,704.5 C 829.5,704.5 834.5,704.5 839.5,704.5C 839.5,709.5 839.5,714.5 839.5,719.5C 834.5,719.5 829.5,719.5 824.5,719.5C 824.5,714.5 824.5,709.5 824.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,704.5 C 844.5,704.5 849.5,704.5 854.5,704.5C 854.5,709.5 854.5,714.5 854.5,719.5C 849.5,719.5 844.5,719.5 839.5,719.5C 839.5,714.5 839.5,709.5 839.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,719.5 C 4.5,719.5 9.5,719.5 14.5,719.5C 14.5,724.5 14.5,729.5 14.5,734.5C 9.5,734.5 4.5,734.5 -0.5,734.5C -0.5,729.5 -0.5,724.5 -0.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,719.5 C 19.5,719.5 24.5,719.5 29.5,719.5C 29.5,724.5 29.5,729.5 29.5,734.5C 24.5,734.5 19.5,734.5 14.5,734.5C 14.5,729.5 14.5,724.5 14.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,719.5 C 34.5,719.5 39.5,719.5 44.5,719.5C 44.5,724.5 44.5,729.5 44.5,734.5C 39.5,734.5 34.5,734.5 29.5,734.5C 29.5,729.5 29.5,724.5 29.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 704.5,719.5 C 704.5,724.5 704.5,729.5 704.5,734.5C 699.5,734.5 694.5,734.5 689.5,734.5C 689.5,729.5 689.5,724.5 689.5,719.5C 694.5,719.5 699.5,719.5 704.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 704.5,719.5 C 709.5,719.5 714.5,719.5 719.5,719.5C 719.5,724.5 719.5,729.5 719.5,734.5C 714.5,734.5 709.5,734.5 704.5,734.5C 704.5,729.5 704.5,724.5 704.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 719.5,719.5 C 724.5,719.5 729.5,719.5 734.5,719.5C 734.5,724.5 734.5,729.5 734.5,734.5C 729.5,734.5 724.5,734.5 719.5,734.5C 719.5,729.5 719.5,724.5 719.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 734.5,719.5 C 739.5,719.5 744.5,719.5 749.5,719.5C 749.5,724.5 749.5,729.5 749.5,734.5C 744.5,734.5 739.5,734.5 734.5,734.5C 734.5,729.5 734.5,724.5 734.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 749.5,719.5 C 754.5,719.5 759.5,719.5 764.5,719.5C 764.5,724.5 764.5,729.5 764.5,734.5C 759.5,734.5 754.5,734.5 749.5,734.5C 749.5,729.5 749.5,724.5 749.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,719.5 C 769.5,719.5 774.5,719.5 779.5,719.5C 779.5,724.5 779.5,729.5 779.5,734.5C 774.5,734.5 769.5,734.5 764.5,734.5C 764.5,729.5 764.5,724.5 764.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,719.5 C 784.5,719.5 789.5,719.5 794.5,719.5C 794.5,724.5 794.5,729.5 794.5,734.5C 789.5,734.5 784.5,734.5 779.5,734.5C 779.5,729.5 779.5,724.5 779.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,719.5 C 799.5,719.5 804.5,719.5 809.5,719.5C 809.5,724.5 809.5,729.5 809.5,734.5C 804.5,734.5 799.5,734.5 794.5,734.5C 794.5,729.5 794.5,724.5 794.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,719.5 C 814.5,719.5 819.5,719.5 824.5,719.5C 824.5,724.5 824.5,729.5 824.5,734.5C 819.5,734.5 814.5,734.5 809.5,734.5C 809.5,729.5 809.5,724.5 809.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,719.5 C 829.5,719.5 834.5,719.5 839.5,719.5C 839.5,724.5 839.5,729.5 839.5,734.5C 834.5,734.5 829.5,734.5 824.5,734.5C 824.5,729.5 824.5,724.5 824.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,719.5 C 844.5,719.5 849.5,719.5 854.5,719.5C 854.5,724.5 854.5,729.5 854.5,734.5C 849.5,734.5 844.5,734.5 839.5,734.5C 839.5,729.5 839.5,724.5 839.5,719.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,734.5 C 4.5,734.5 9.5,734.5 14.5,734.5C 14.5,739.5 14.5,744.5 14.5,749.5C 9.5,749.5 4.5,749.5 -0.5,749.5C -0.5,744.5 -0.5,739.5 -0.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,734.5 C 19.5,734.5 24.5,734.5 29.5,734.5C 29.5,739.5 29.5,744.5 29.5,749.5C 24.5,749.5 19.5,749.5 14.5,749.5C 14.5,744.5 14.5,739.5 14.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,734.5 C 34.5,734.5 39.5,734.5 44.5,734.5C 44.5,739.5 44.5,744.5 44.5,749.5C 39.5,749.5 34.5,749.5 29.5,749.5C 29.5,744.5 29.5,739.5 29.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 674.5,734.5 C 674.5,739.5 674.5,744.5 674.5,749.5C 669.5,749.5 664.5,749.5 659.5,749.5C 659.5,744.5 659.5,739.5 659.5,734.5C 664.5,734.5 669.5,734.5 674.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 674.5,734.5 C 679.5,734.5 684.5,734.5 689.5,734.5C 689.5,739.5 689.5,744.5 689.5,749.5C 684.5,749.5 679.5,749.5 674.5,749.5C 674.5,744.5 674.5,739.5 674.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 689.5,734.5 C 694.5,734.5 699.5,734.5 704.5,734.5C 704.5,739.5 704.5,744.5 704.5,749.5C 699.5,749.5 694.5,749.5 689.5,749.5C 689.5,744.5 689.5,739.5 689.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 704.5,734.5 C 709.5,734.5 714.5,734.5 719.5,734.5C 719.5,739.5 719.5,744.5 719.5,749.5C 714.5,749.5 709.5,749.5 704.5,749.5C 704.5,744.5 704.5,739.5 704.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 719.5,734.5 C 724.5,734.5 729.5,734.5 734.5,734.5C 734.5,739.5 734.5,744.5 734.5,749.5C 729.5,749.5 724.5,749.5 719.5,749.5C 719.5,744.5 719.5,739.5 719.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 734.5,734.5 C 739.5,734.5 744.5,734.5 749.5,734.5C 749.5,739.5 749.5,744.5 749.5,749.5C 744.5,749.5 739.5,749.5 734.5,749.5C 734.5,744.5 734.5,739.5 734.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 749.5,734.5 C 754.5,734.5 759.5,734.5 764.5,734.5C 764.5,739.5 764.5,744.5 764.5,749.5C 759.5,749.5 754.5,749.5 749.5,749.5C 749.5,744.5 749.5,739.5 749.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 764.5,734.5 C 769.5,734.5 774.5,734.5 779.5,734.5C 779.5,739.5 779.5,744.5 779.5,749.5C 774.5,749.5 769.5,749.5 764.5,749.5C 764.5,744.5 764.5,739.5 764.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 779.5,734.5 C 784.5,734.5 789.5,734.5 794.5,734.5C 794.5,739.5 794.5,744.5 794.5,749.5C 789.5,749.5 784.5,749.5 779.5,749.5C 779.5,744.5 779.5,739.5 779.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 794.5,734.5 C 799.5,734.5 804.5,734.5 809.5,734.5C 809.5,739.5 809.5,744.5 809.5,749.5C 804.5,749.5 799.5,749.5 794.5,749.5C 794.5,744.5 794.5,739.5 794.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 809.5,734.5 C 814.5,734.5 819.5,734.5 824.5,734.5C 824.5,739.5 824.5,744.5 824.5,749.5C 819.5,749.5 814.5,749.5 809.5,749.5C 809.5,744.5 809.5,739.5 809.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 824.5,734.5 C 829.5,734.5 834.5,734.5 839.5,734.5C 839.5,739.5 839.5,744.5 839.5,749.5C 834.5,749.5 829.5,749.5 824.5,749.5C 824.5,744.5 824.5,739.5 824.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 839.5,734.5 C 844.5,734.5 849.5,734.5 854.5,734.5C 854.5,739.5 854.5,744.5 854.5,749.5C 849.5,749.5 844.5,749.5 839.5,749.5C 839.5,744.5 839.5,739.5 839.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,749.5 C 4.5,749.5 9.5,749.5 14.5,749.5C 14.5,754.5 14.5,759.5 14.5,764.5C 9.5,764.5 4.5,764.5 -0.5,764.5C -0.5,759.5 -0.5,754.5 -0.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,749.5 C 19.5,749.5 24.5,749.5 29.5,749.5C 29.5,754.5 29.5,759.5 29.5,764.5C 24.5,764.5 19.5,764.5 14.5,764.5C 14.5,759.5 14.5,754.5 14.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,749.5 C 34.5,749.5 39.5,749.5 44.5,749.5C 44.5,754.5 44.5,759.5 44.5,764.5C 39.5,764.5 34.5,764.5 29.5,764.5C 29.5,759.5 29.5,754.5 29.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 659.5,749.5 C 659.5,754.5 659.5,759.5 659.5,764.5C 654.5,764.5 649.5,764.5 644.5,764.5C 644.5,759.5 644.5,754.5 644.5,749.5C 649.5,749.5 654.5,749.5 659.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 659.5,749.5 C 664.5,749.5 669.5,749.5 674.5,749.5C 674.5,754.5 674.5,759.5 674.5,764.5C 669.5,764.5 664.5,764.5 659.5,764.5C 659.5,759.5 659.5,754.5 659.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 674.5,749.5 C 679.5,749.5 684.5,749.5 689.5,749.5C 689.5,754.5 689.5,759.5 689.5,764.5C 684.5,764.5 679.5,764.5 674.5,764.5C 674.5,759.5 674.5,754.5 674.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 689.5,749.5 C 694.5,749.5 699.5,749.5 704.5,749.5C 704.5,754.5 704.5,759.5 704.5,764.5C 699.5,764.5 694.5,764.5 689.5,764.5C 689.5,759.5 689.5,754.5 689.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 704.5,749.5 C 709.5,749.5 714.5,749.5 719.5,749.5C 719.5,754.5 719.5,759.5 719.5,764.5C 714.5,764.5 709.5,764.5 704.5,764.5C 704.5,759.5 704.5,754.5 704.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 719.5,749.5 C 724.5,749.5 729.5,749.5 734.5,749.5C 734.5,754.5 734.5,759.5 734.5,764.5C 729.5,764.5 724.5,764.5 719.5,764.5C 719.5,759.5 719.5,754.5 719.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 734.5,749.5 C 739.5,749.5 744.5,749.5 749.5,749.5C 749.5,754.5 749.5,759.5 749.5,764.5C 744.5,764.5 739.5,764.5 734.5,764.5C 734.5,759.5 734.5,754.5 734.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 749.5,749.5 C 754.5,749.5 759.5,749.5 764.5,749.5C 764.5,754.5 764.5,759.5 764.5,764.5C 759.5,764.5 754.5,764.5 749.5,764.5C 749.5,759.5 749.5,754.5 749.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 764.5,749.5 C 769.5,749.5 774.5,749.5 779.5,749.5C 779.5,754.5 779.5,759.5 779.5,764.5C 774.5,764.5 769.5,764.5 764.5,764.5C 764.5,759.5 764.5,754.5 764.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 779.5,749.5 C 784.5,749.5 789.5,749.5 794.5,749.5C 794.5,754.5 794.5,759.5 794.5,764.5C 789.5,764.5 784.5,764.5 779.5,764.5C 779.5,759.5 779.5,754.5 779.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 794.5,749.5 C 799.5,749.5 804.5,749.5 809.5,749.5C 809.5,754.5 809.5,759.5 809.5,764.5C 804.5,764.5 799.5,764.5 794.5,764.5C 794.5,759.5 794.5,754.5 794.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 809.5,749.5 C 814.5,749.5 819.5,749.5 824.5,749.5C 824.5,754.5 824.5,759.5 824.5,764.5C 819.5,764.5 814.5,764.5 809.5,764.5C 809.5,759.5 809.5,754.5 809.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 824.5,749.5 C 829.5,749.5 834.5,749.5 839.5,749.5C 839.5,754.5 839.5,759.5 839.5,764.5C 834.5,764.5 829.5,764.5 824.5,764.5C 824.5,759.5 824.5,754.5 824.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 839.5,749.5 C 844.5,749.5 849.5,749.5 854.5,749.5C 854.5,754.5 854.5,759.5 854.5,764.5C 849.5,764.5 844.5,764.5 839.5,764.5C 839.5,759.5 839.5,754.5 839.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M -0.5,764.5 C 4.5,764.5 9.5,764.5 14.5,764.5C 14.5,769.5 14.5,774.5 14.5,779.5C 9.5,779.5 4.5,779.5 -0.5,779.5C -0.5,774.5 -0.5,769.5 -0.5,764.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 14.5,764.5 C 19.5,764.5 24.5,764.5 29.5,764.5C 29.5,769.5 29.5,774.5 29.5,779.5C 24.5,779.5 19.5,779.5 14.5,779.5C 14.5,774.5 14.5,769.5 14.5,764.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 29.5,764.5 C 34.5,764.5 39.5,764.5 44.5,764.5C 44.5,769.5 44.5,774.5 44.5,779.5C 39.5,779.5 34.5,779.5 29.5,779.5C 29.5,774.5 29.5,769.5 29.5,764.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 314.5,779.5 C 309.5,779.5 304.5,779.5 299.5,779.5C 299.5,774.5 299.5,769.5 299.5,764.5C 304.5,764.5 309.5,764.5 314.5,764.5C 314.5,769.5 314.5,774.5 314.5,779.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M -0.5,779.5 C 4.5,779.5 9.5,779.5 14.5,779.5C 14.5,784.5 14.5,789.5 14.5,794.5C 9.5,794.5 4.5,794.5 -0.5,794.5C -0.5,789.5 -0.5,784.5 -0.5,779.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 14.5,779.5 C 19.5,779.5 24.5,779.5 29.5,779.5C 29.5,784.5 29.5,789.5 29.5,794.5C 24.5,794.5 19.5,794.5 14.5,794.5C 14.5,789.5 14.5,784.5 14.5,779.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 29.5,779.5 C 34.5,779.5 39.5,779.5 44.5,779.5C 44.5,784.5 44.5,789.5 44.5,794.5C 39.5,794.5 34.5,794.5 29.5,794.5C 29.5,789.5 29.5,784.5 29.5,779.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e6e5",
    d: "M 359.5,794.5 C 354.5,794.5 349.5,794.5 344.5,794.5C 344.5,789.5 344.5,784.5 344.5,779.5C 349.5,779.5 354.5,779.5 359.5,779.5C 359.5,784.5 359.5,789.5 359.5,794.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebebeb",
    d: "M -0.5,794.5 C 4.5,794.5 9.5,794.5 14.5,794.5C 19.5,794.5 24.5,794.5 29.5,794.5C 34.5,794.5 39.5,794.5 44.5,794.5C 44.5,799.5 44.5,804.5 44.5,809.5C 49.5,809.5 54.5,809.5 59.5,809.5C 59.5,804.5 59.5,799.5 59.5,794.5C 64.5,794.5 69.5,794.5 74.5,794.5C 74.5,799.5 74.5,804.5 74.5,809.5C 79.5,809.5 84.5,809.5 89.5,809.5C 89.5,804.5 89.5,799.5 89.5,794.5C 94.5,794.5 99.5,794.5 104.5,794.5C 104.5,799.5 104.5,804.5 104.5,809.5C 109.5,809.5 114.5,809.5 119.5,809.5C 119.5,804.5 119.5,799.5 119.5,794.5C 124.5,794.5 129.5,794.5 134.5,794.5C 134.5,799.5 134.5,804.5 134.5,809.5C 139.5,809.5 144.5,809.5 149.5,809.5C 149.5,804.5 149.5,799.5 149.5,794.5C 154.5,794.5 159.5,794.5 164.5,794.5C 164.5,799.5 164.5,804.5 164.5,809.5C 169.5,809.5 174.5,809.5 179.5,809.5C 179.5,804.5 179.5,799.5 179.5,794.5C 184.5,794.5 189.5,794.5 194.5,794.5C 194.5,799.5 194.5,804.5 194.5,809.5C 199.5,809.5 204.5,809.5 209.5,809.5C 209.5,804.5 209.5,799.5 209.5,794.5C 214.5,794.5 219.5,794.5 224.5,794.5C 224.5,799.5 224.5,804.5 224.5,809.5C 229.5,809.5 234.5,809.5 239.5,809.5C 239.5,804.5 239.5,799.5 239.5,794.5C 244.5,794.5 249.5,794.5 254.5,794.5C 254.5,799.5 254.5,804.5 254.5,809.5C 259.5,809.5 264.5,809.5 269.5,809.5C 269.5,804.5 269.5,799.5 269.5,794.5C 274.5,794.5 279.5,794.5 284.5,794.5C 284.5,799.5 284.5,804.5 284.5,809.5C 289.5,809.5 294.5,809.5 299.5,809.5C 299.5,804.5 299.5,799.5 299.5,794.5C 304.5,794.5 309.5,794.5 314.5,794.5C 314.5,799.5 314.5,804.5 314.5,809.5C 319.5,809.5 324.5,809.5 329.5,809.5C 329.5,804.5 329.5,799.5 329.5,794.5C 334.5,794.5 339.5,794.5 344.5,794.5C 349.5,794.5 354.5,794.5 359.5,794.5C 364.5,794.5 369.5,794.5 374.5,794.5C 374.5,799.5 374.5,804.5 374.5,809.5C 379.5,809.5 384.5,809.5 389.5,809.5C 389.5,804.5 389.5,799.5 389.5,794.5C 394.5,794.5 399.5,794.5 404.5,794.5C 404.5,799.5 404.5,804.5 404.5,809.5C 409.5,809.5 414.5,809.5 419.5,809.5C 419.5,804.5 419.5,799.5 419.5,794.5C 424.5,794.5 429.5,794.5 434.5,794.5C 434.5,799.5 434.5,804.5 434.5,809.5C 439.5,809.5 444.5,809.5 449.5,809.5C 449.5,804.5 449.5,799.5 449.5,794.5C 454.5,794.5 459.5,794.5 464.5,794.5C 464.5,799.5 464.5,804.5 464.5,809.5C 469.5,809.5 474.5,809.5 479.5,809.5C 479.5,804.5 479.5,799.5 479.5,794.5C 484.5,794.5 489.5,794.5 494.5,794.5C 494.5,799.5 494.5,804.5 494.5,809.5C 499.5,809.5 504.5,809.5 509.5,809.5C 509.5,804.5 509.5,799.5 509.5,794.5C 514.5,794.5 519.5,794.5 524.5,794.5C 524.5,799.5 524.5,804.5 524.5,809.5C 529.5,809.5 534.5,809.5 539.5,809.5C 539.5,804.5 539.5,799.5 539.5,794.5C 544.5,794.5 549.5,794.5 554.5,794.5C 554.5,799.5 554.5,804.5 554.5,809.5C 559.5,809.5 564.5,809.5 569.5,809.5C 569.5,804.5 569.5,799.5 569.5,794.5C 574.5,794.5 579.5,794.5 584.5,794.5C 584.5,799.5 584.5,804.5 584.5,809.5C 589.5,809.5 594.5,809.5 599.5,809.5C 599.5,804.5 599.5,799.5 599.5,794.5C 604.5,794.5 609.5,794.5 614.5,794.5C 614.5,799.5 614.5,804.5 614.5,809.5C 619.5,809.5 624.5,809.5 629.5,809.5C 629.5,804.5 629.5,799.5 629.5,794.5C 634.5,794.5 639.5,794.5 644.5,794.5C 644.5,799.5 644.5,804.5 644.5,809.5C 649.5,809.5 654.5,809.5 659.5,809.5C 659.5,804.5 659.5,799.5 659.5,794.5C 664.5,794.5 669.5,794.5 674.5,794.5C 674.5,799.5 674.5,804.5 674.5,809.5C 679.5,809.5 684.5,809.5 689.5,809.5C 689.5,804.5 689.5,799.5 689.5,794.5C 694.5,794.5 699.5,794.5 704.5,794.5C 704.5,799.5 704.5,804.5 704.5,809.5C 709.5,809.5 714.5,809.5 719.5,809.5C 719.5,804.5 719.5,799.5 719.5,794.5C 724.5,794.5 729.5,794.5 734.5,794.5C 734.5,799.5 734.5,804.5 734.5,809.5C 739.5,809.5 744.5,809.5 749.5,809.5C 749.5,804.5 749.5,799.5 749.5,794.5C 754.5,794.5 759.5,794.5 764.5,794.5C 764.5,799.5 764.5,804.5 764.5,809.5C 769.5,809.5 774.5,809.5 779.5,809.5C 779.5,804.5 779.5,799.5 779.5,794.5C 784.5,794.5 789.5,794.5 794.5,794.5C 794.5,799.5 794.5,804.5 794.5,809.5C 799.5,809.5 804.5,809.5 809.5,809.5C 809.5,804.5 809.5,799.5 809.5,794.5C 814.5,794.5 819.5,794.5 824.5,794.5C 824.5,799.5 824.5,804.5 824.5,809.5C 829.5,809.5 834.5,809.5 839.5,809.5C 839.5,804.5 839.5,799.5 839.5,794.5C 844.5,794.5 849.5,794.5 854.5,794.5C 854.5,799.5 854.5,804.5 854.5,809.5C 859.5,809.5 864.5,809.5 869.5,809.5C 869.5,804.5 869.5,799.5 869.5,794.5C 874.5,794.5 879.5,794.5 884.5,794.5C 884.5,799.5 884.5,804.5 884.5,809.5C 889.5,809.5 894.5,809.5 899.5,809.5C 899.5,811.167 899.5,812.833 899.5,814.5C 599.5,814.5 299.5,814.5 -0.5,814.5C -0.5,807.833 -0.5,801.167 -0.5,794.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcomm);
export default __webpack_public_path__ + "static/media/ecomm.19e451a01fec70719bbb420e5572a23a.svg";
export { ForwardRef as ReactComponent };